import { Component, OnInit, ViewEncapsulation, ViewChild, ElementRef, AfterViewInit, NgZone, OnDestroy} from '@angular/core';
import { AuthenticationService } from '../services/authentication.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { MultilanguageService } from '../../shared/services/multilanguage.service';
import { FormGroup, FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import { CommonService } from '../../shared/services/common.service';
import { LoginUserInstances, RguestLoginpayload, RguestSsoMobilePayload, SSOLoginData, UserData, UserInstances, UserSiteRole } from '../../shared/models/Account/UserInstancesEntity';
import { SiteEntity } from '../../shared/models/Account/SiteEntity';
import * as appApiResources from '../../shared/globalcontants';
import { APIServiceProviderService } from '../../shared/services/APIServices/APIServiceProviderService/APIServiceProviderService';
import { TokenUserAccessEntity, UserInfoEntity } from '../../shared/models/Account/UserInfoEntity ';
import { CSharpRequestService } from 'src/app/shared/services/csharp-request.service';
import { cSharpActionName } from '../../shared/globalcontants';
import moment from 'moment-timezone';
import { ApplicationUserEntity } from 'src/app/shared/models/Account/ApplicationUserEntity';
import { LoginErrorEntity } from 'src/app/shared/models/Utilities/ValidationEntity';
import  jwt_decode from 'jwt-decode';
import { AuthorizationConfig } from 'src/app/authorization/privilege-authorization.modal';
import { PrevilegeAuthorizationService } from 'src/app/authorization/services/privilege-authorization.service';
import { UserLicenceDetailsEntity } from '../../shared/models/Licence/UserLicenceDetailsEntity';
import { HttpClient } from '@angular/common/http';
import { RolesEntity } from 'src/app/shared/models/Account/RoleEntity';
import { SessionStorageService } from 'src/app/shared/services/session-storage.service';
import { LocationPayloadEntity } from 'src/app/shared/models/Location/LocationEntity';
import { UIMenuEntity } from 'src/app/shared/models/Application/UIMenuEntity';
import { RequestService } from 'src/app/shared/services/RequestServices/Request-Service';
import { SetupService } from 'src/app/shared/services/APIServices/SetupService/SetupService';
import { OdataConfigurationService } from 'src/app/shared/services/odata-configuration.service';
import { PopupComponent } from 'src/app/shared/popup/popup.component';
import { MatDialog } from '@angular/material/dialog';
import { GlobalConversionService } from 'src/app/shared/services/GlobalMethodService/GlobalConversion-Service';
import { QueryParams } from 'src/app/shared/models/Utilities/QueryParamEntity';
import { AzureInfoService } from 'src/app/msal-module/azure-info.service';
import { AzureAdModel, OAuthSettingsConfig, TenantInformation, VerFiedUserModel } from 'src/app/msal-module/azure-ad.interface';
import { HttpRequestService } from 'src/app/shared/services/http-request.service';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { filter, takeUntil } from 'rxjs/operators';
import { AuthenticationResult, Configuration, EventMessage, EventType, InteractionStatus, PublicClientApplication } from '@azure/msal-browser';
import { Subject } from 'rxjs';
import { ConfigService } from 'src/app/config.service';
import { LoginAuthentication } from 'src/app/shared/models/Utilities/CommonEntity';
import * as GlobalConstant from  '../../shared/globalcontants'
import * as constants from '../../../app/shared/globalcontants';
import { GetMSALConfig } from 'src/app/msal-config-dynamic.module';
import { LoaderService } from '../services/loader.service';
import { EatecTokenRefreshService } from '../services/eatec-token-refresh.service';
import { AgilysysChangePasswordPopupComponent } from 'src/app/shared/popup/agilysys-change-password-popup/agilysys-change-password-popup.component';
import { AddNewPopModel } from 'src/app/shared/models/pop-up.interface';
import { PasswordComplexityCheck } from 'src/app/shared/interface/password-complexity-condition.interface';
import { NgClass } from '@angular/common';
import { MatLabel, MatFormField, MatPrefix, MatInput, MatSuffix } from '@angular/material/input';
import { AutoFocusDirective } from '../../shared/directives/auto-focus.directive';
import { MatButton } from '@angular/material/button';
import { SpinnerComponent } from '../../shared/spinner/spinner.component';
import { ToastMessageComponent } from '../../shared/toast-message/toast-message.component';
export class Claim {
  id: number;
  claim: string;
  value: string;
}
export interface OdataGlobalEntity {
  OdataViewModelEntity: any;
  OdataPostModelEntity: any;
}

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [NgClass, ReactiveFormsModule, MatLabel, MatFormField, MatPrefix, MatInput, AutoFocusDirective, MatSuffix, MatButton, SpinnerComponent, ToastMessageComponent, TranslateModule]
})
export class LoginComponent implements OnInit, AfterViewInit, OnDestroy {
  loginType: any;
  loginForm: FormGroup;
  locationFrom: FormGroup;
  loginError = '';
  public loggedInUserId = 0;
  public loggedInUserName = '';
  public loggedInSiteId = 0;
  public usertoken: any;
  public SelectedInstance: any;
  public ClientId: any;
  imageSource: any;
  letter: String;
  public LoginInstances: LoginUserInstances; // 13.1 Modernization
  public Sites: SiteEntity[] = [];
  public Roles: RolesEntity[] = []; // 13.1 Modernization
  public Instances: UserInstances[] = [];
  hidePassword = true;
  focusVariable: any = false;
  @ViewChild('someInput') someInput: ElementRef;
  @ViewChild('password', { read: ElementRef }) password: ElementRef;
  public UserInfo: UserInfoEntity;
  public defaultClient_Id: string;
  public ClinetId: string;
  public defaultSiteId: number;
  public defaultSiteName: string;
  public defaultSiteAbbreviation: string;
  public defaultInstanceName: string;
  public siteName: string;
  public siteAbbreviation: string;
  private siteAbb: string;
  public apiUrl: string = window.localStorage.getItem('apiUrl');
  public version: string = window.localStorage.getItem('version');
  public showSettingsicon = true;
  public toastShow = false;
  public toastMessage: string;
  public buttonText: string;
  public rGuestPassword: string;
  private settingjsonpath: string;
  appsettings: any;
  appVersion: any;
  logoUrl: string;
  common: any;
  OdataCollection: OdataGlobalEntity;
  isOneSite = false;
  isOneRole = false;
  authenticated: boolean;
  userAgentApp: any;
  azureMsal: any;
  loginDisplay = false;
  private readonly _destroying$ = new Subject<void>();
  UpdatedMsal:PublicClientApplication;
  IsAdUser:boolean;
  adDataInfo: any;
  adTenantName:string;
  RGuestTenantCode:any;
  RGuestTenantId:any;
  RGuestUrl:any;
  RguestProductID:any;
  IsRguest:any;
  userValidation =false;
  loginControlAuth: LoginAuthentication;
  EnableProductAuthentication: boolean;
  B2CLoginUserFlow: string;
  LoginAzureType: any;
  UserEmail : string;
  copyRightYear: string;
  IntegrationConfig: any;
  navigationMenu: any;
  LanguageCode: any;
  IsAgilysysEmployee = false;
  showLoginError = false;
  loginErrorText: any;
  PasswordComplexityConditionsData: any;
  constructor(
    private _ngZone: NgZone,
    private csharpService: CSharpRequestService,
    private authentication: AuthenticationService,
    public commnService: CommonService,
    public formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    public translate: TranslateService,
    private _ml: MultilanguageService,
    private apiServiceProviderService: APIServiceProviderService,
    private _ts: TranslateService,
    private previlegeAuthorizationService: PrevilegeAuthorizationService,
    private http: HttpClient,
    private _sessionStorage: SessionStorageService,
    private requestService: RequestService,
    private setupService: SetupService,
    private odataConfigurationService: OdataConfigurationService,
    private dialog: MatDialog,
    private GlobalConversionService: GlobalConversionService,
    private azureInfoService: AzureInfoService,
    private httpservice: HttpRequestService,
    private authService: MsalService,
    private broadcastService: MsalBroadcastService, 
    private azureConfig: ConfigService,
    private loaderService: LoaderService,
    private eatecTokenRefreshService: EatecTokenRefreshService
  ) {
    this.copyRightYear = ` ${ moment().year() }`;
    this.commnService.IsLoginPage = true;
    this.common = this._ts.instant('common');
    this.showSettingsicon = true;
    this.commnService.onlineStatusChange.subscribe((value) => {
      this.showSettingsicon = value;
      if(value){
        this.userValidation = false;
      }
    });
     // Based on this 363269 Eatec Mobile Not Supported In IC
    // this.commnService.IsRguest = this._sessionStorage.localStorageGetItem(appApiResources.IsRguest, true);
    this.commnService.IsRguest = false;
    const ImageLog = (this.commnService.IsRguest) ? 'spa_logo.png' : 'EatecDarklogo.png';
    const eatecLogo = 'AgilysysEatec-Color.png'
    this.logoUrl = `assets/images/${eatecLogo}`;

    window['loginComponentRef'] = {
      zone: this._ngZone,
      LoginResult: (response) => this.LoginResult(response),
      BindSites: (listSitesObj) => this.BindSites(listSitesObj),
      SaveUserDeatils: (response) => this.SaveUserDeatils(response),
      RedirectToLogin:() => this.RedirectToLogin(),
      LoadMasterDataComplete: () => this.LoadMasterDataComplete(),
      BindEatecGlobalSettings: (value) => this.BindEatecGlobalSettings(value),
      BindPocketMenu: (MenuItems) => this.BindPocketMenu(MenuItems),
      BindGetReceivingLocations: (value) => this.BindGetReceivingLocations(value),
      BindSupplierDetails: (value) => this.BindSupplierDetails(value),
      SaveDeviceInformation: (value) => this.SaveDeviceInformation(value),
      UserAccess: (response) => this.UserAccess(response),
      GetSiteLocationIds: (response) => this.GetSiteLocationIds(response),
      GetODataCollection: (response) => this.GetODataCollection(response),
      BindGetCurrencies:(response) => this.BindGetCurrencies(response),
      BindGetUserConfig: (reponse) => this.BindGetUserConfig(reponse),
      component: this,
    };
    this.loginForm = this.formBuilder.group({
      username: ['', Validators.required],
      password: ['', Validators.required],
    });
    this.locationFrom = this.formBuilder.group({
      instance: ['', Validators.required],
      site: ['', Validators.required]
    });
    this.focusVariable = false;
    this.letter = appApiResources.letters.c;
    this.adDataInfo = this.azureConfig.getSettings('AdData');
    this.EnableProductAuthentication = this.azureConfig.getSettings('EnableProductAuthentication');
    this.B2CLoginUserFlow = this.azureConfig.getSettings('B2CLoginUserFlow')
    this.IsAdUser = ( this.adDataInfo && this.adDataInfo.IsAdEnabled ) ? true : false;
    this.loginControlAuth = this.commnService.loginAuthAlgorithm(this.adDataInfo, this.EnableProductAuthentication)
    this.adTenantName = this.azureConfig.getSettings().TenantIdentifier;
    this.RGuestTenantCode = this.azureConfig.getSettings('RguestTenantCode')
    this.RGuestTenantId = this.azureConfig.getSettings('RGuestTenantId')
    this.RGuestUrl = this.azureConfig.getSettings('RGuestSSOAuthURL')
    this.RguestProductID = this.azureConfig.getSettings('RguestProductId');
    // Based on this 363269 Eatec Mobile Not Supported In IC
    // this.IsRguest = this.azureConfig.getSettings('IsRguest')
    this.IsRguest = false;
    this.commnService.SystemConfig = {};
    this.azureConfig.getSettings('SystemConfig')?.forEach(m => {
      this.commnService.SystemConfig[m.ConfigKey] = m.ConfigValue;
    });
    if(Object.keys(this.commnService.SystemConfig)?.length) {
      localStorage.setItem('systemConfig', JSON.stringify(this.commnService.SystemConfig));
    }
    this.IntegrationConfig = this.azureConfig?.getSettings()?.IntegrationConfig;
    this.apiServiceProviderService.utilityService.DateFormat = localStorage.getItem('dateFormate') != null && localStorage.getItem('dateFormate') != undefined ? localStorage.getItem('dateFormate') : this.azureConfig.getSettings('DateConfig');
    if(!localStorage.hasOwnProperty('dateFormate')){
      localStorage.setItem('dateFormate',this.azureConfig.getSettings('DateConfig'));
    }
    localStorage.setItem('DefaultAlertPeriod',this.azureConfig.getSettings('DefaultAlertPeriod'));
    localStorage.setItem(appApiResources.RguestLoginURL,this.RGuestUrl);
    localStorage.setItem(appApiResources.RGuestProductId,this.RguestProductID);
    localStorage.setItem(appApiResources.RGuestTenantCode,this.RGuestTenantCode);
    localStorage.setItem(appApiResources.RGuestTenantId,this.RGuestTenantId);
     // Based on this 363269 Eatec Mobile Not Supported In IC
    // localStorage.setItem(appApiResources.IsRguest,this.azureConfig.getSettings('IsRguest'));
    localStorage.setItem(appApiResources.IsRguest, 'false');
    localStorage.setItem(appApiResources.IntegrationConfig, this.IntegrationConfig);
    localStorage.setItem(appApiResources.IsAD,this.IsAdUser.toString());
    localStorage.setItem('TenantId',this.azureConfig.getSettings('TenantId')?.toString());
    this.commnService.RGuestProductId = this.RguestProductID;
    this.commnService.RGuestTenantCode = this.RGuestTenantCode;
    this.commnService.RGuestTenantId = this.RGuestTenantId;
    this.commnService.IsRguest = this.IsRguest;
    this.commnService.rguestLoginUrl = this.RGuestUrl;
  }

  RedirectToLogin(){
    if(!this.userValidation){
      this.dialog.closeAll();
      this.openPopup('Alert', "Eatec Mobile is offline or connection is interrupted. Please connect to internet/mobile data to continue with mobile offline support master database import", '', 'OK','syncfalied');
    }    
    localStorage.setItem('masterDataSynced', 'false');      
  }
  ChangeLanguage(selectlang: any) {
    const value = selectlang.toString();
    this._ml.SetLanguage(value);
    sessionStorage.setItem('lang', value);
  }

  changeView() {
    this.someInput.nativeElement.focus();
  }
  setLoginDisplay() {
    this.loginDisplay = this.authService.instance.getAllAccounts().length > 0;
    console.log(this.loginDisplay)
  }

  async ngOnInit() {
        this.commnService.IsLoginPage = true;
    this.commnService.fromOfflineSync = false;
    // Set up MSAL event subscriptions BEFORE initialize() so events fired during
    // APP_INITIALIZER's handleRedirectObservable() processing are not missed.
    this.broadcastService.inProgress$
      .pipe(
        filter((status: InteractionStatus) => status === InteractionStatus.None),
        takeUntil(this._destroying$)
      )
      .subscribe((x) => {
        console.log('Progress', x);
        this.setLoginDisplay();
        // this.checkAndSetActiveAccount();
        this.getClaims(this.authService.instance.getActiveAccount()?.idTokenClaims)
        this.authentication.clearLocalStorage();
      })
    this.broadcastService.msalSubject$
      .pipe(
        filter((msg: EventMessage) => msg.eventType === EventType.LOGIN_SUCCESS),
        takeUntil(this._destroying$)
      )
      .subscribe((result: EventMessage) => {
        console.log('LOGIN_SUCCESS', result);
        const payload = result.payload as AuthenticationResult;
        const accessTokenRequest = {
          scopes: payload?.scopes,
          account: payload?.account
        }
        this.authService.instance?.acquireTokenSilent(accessTokenRequest);
      });
    this.broadcastService.msalSubject$
      .pipe(
        filter((msg: EventMessage) => msg.eventType === EventType.ACQUIRE_TOKEN_SUCCESS),
        takeUntil(this._destroying$)
      )
      .subscribe((result: EventMessage) => {
        console.log('sailentToken', result);
        const payload = result.payload as AuthenticationResult;
        this.authService.instance?.setActiveAccount(payload?.account);
        const resultReturnToken = (this.adDataInfo?.AzureAdType) ? payload?.idToken : payload?.accessToken;
        const tenantInfo = {} as TenantInformation;
        tenantInfo.AzureAdType = this.adDataInfo?.AzureAdType;
        this.UserEmail = this.azureAdVerifyEmail(payload) || this.UserEmail;
        this.IsAgilysysEmployee = localStorage.getItem('IsAgilysysEmployee') === 'true';
          if (!this.commnService.isSettings) {
          this.CallUserAPI(resultReturnToken, tenantInfo)?.subscribe({
            next: response => {
              if (response) {
                this.adCallBack(response);
              }
            },
            error: async err => {
              console.error('Failed to clear invalid MSAL account', err);
            }
          });
        }
      });   
    await this.authService.instance.initialize();
    this.apiServiceProviderService.utilityService.DateFormat = localStorage.getItem('dateFormate') != null && localStorage.getItem('dateFormate') != undefined ? localStorage.getItem('dateFormate') : this.azureConfig.getSettings('DateConfig');
    if (!this.csharpService.IsLoadFromApp) {
      this.settingjsonpath = './appsettings.json';
      await this.http.get(this.settingjsonpath)?.toPromise()?.then(async res => {
        if (res) {
          this.appsettings = res;
          if ((this.apiUrl == null || this.apiUrl === '')
            && (this.commnService.apiUrl == null || this.commnService.apiUrl === '' || this.commnService.apiUrl === undefined)) {
            window.localStorage.setItem('apiUrl', this.appsettings.Api_Url);
            this.apiUrl = this.appsettings.Api_Url;
            this.commnService.apiUrl = this.appsettings.Api_Url;
          }
          window.localStorage.setItem(appApiResources.IntegrationConfig, this.IntegrationConfig);
          localStorage.setItem('editionId', this.appsettings.EditionId);
          localStorage.setItem('RequisitionRequired', this.appsettings.RequisitionRequired);
          localStorage.setItem('EnableClassCalendarIntegration', this.appsettings.EnableClassCalendarIntegration);
          await this.commnService.getTenantConfig();
        }
      });
    }
      const sourceObj = {
        componentName: appApiResources.ComponentNameReferences.Login,
        funcName: appApiResources.CSharpCallBackFunctions.GetDeviceInformationCallBack,
        Action: appApiResources.cSharpActionName.GetDeviceInfo
      };
      this.csharpService.RequestGETCSharp(appApiResources.cSharpURLs.DeviceInfo, sourceObj);
    localStorage.setItem(appApiResources.DeviceId, '');
    localStorage.setItem(appApiResources.DeviceName, '');
    localStorage.setItem(appApiResources.DeviceType, '');
    this.loginType = 'Login';
    if (!this.commnService.apiUrl) {
      if (localStorage.hasOwnProperty('apiUrl')) {
        const apiUrl = window.localStorage.getItem('apiUrl');
        this.commnService.apiUrl = apiUrl;
        this.apiUrl = apiUrl;
      }
    } else {
      window.localStorage.setItem('apiUrl', this.commnService.apiUrl);
      this.commnService.getTenantConfig();
    }

    window.localStorage.setItem('searchChar', '3');
    window.localStorage.setItem('quantityFocus', ((this.commnService.quantityFocus === null ) ? 'true' : this.commnService.quantityFocus ));
    window.localStorage.setItem('LocalBarcodeScan', ((this.commnService.LocalBarcodeScan === null ) ? 'false' : this.commnService.LocalBarcodeScan));
    window.localStorage.setItem('barcodeAutoIncrement', this.commnService.barcodeAutoIncrement);
    window.localStorage.setItem('newBarcode', this.commnService.barCode.toString());
    appApiResources.normalizeLegacySessionIndex();
    const sessionIdx = appApiResources.resolveSessionPresetIndex();
    window.localStorage.setItem('session', String(sessionIdx));
    window.localStorage.setItem('sessionToggle', 'true');
    this.commnService.sessiontoggle = 'true';
    const timeInSeconds = appApiResources.sessionPresetIndexToIdleSeconds(sessionIdx);
    window.localStorage.setItem('idleTimeout', String(timeInSeconds));
    this.commnService.InactivityTimeout.next(timeInSeconds);
    this.commnService.session = String(sessionIdx);
    window.localStorage.setItem('autoSync', this.commnService.autoSync);
    // window.localStorage.setItem("version", this.commnService.version);
    window.localStorage.setItem('soundmode', this.commnService.scansoundmode);
    this.buttonText = this._ts.instant('common.dismiss');

    if (this.commnService.showSettingToast) {
      this.showToastMessage(this.commnService.showSettingToastText);
      this.commnService.showSettingToast = false;
    }
    this.commnService.activeMenuChange.next('0');

    this.navigationMenu = await this.http.get<Array<any>>('assets/json/navigation-menu.json').toPromise();     
    // Check for token in URL query parameters for SAML verification
    const queryParams = this.route?.snapshot?.queryParams;
    if (queryParams?.token) {
      this.httpservice.postHttpRequest('/usermgmt/api/saml/verify', { token: queryParams.token }).subscribe(response => {
        if (response) {
          this.adCallBack(response);
        }
        const hashParts = window?.location?.hash?.split('?');
        if (hashParts?.length) {
          window.history.replaceState({}, '', `${window.location.pathname}${hashParts[0]}`);
        }
      });
    } else if (queryParams?.EmailId) {
      const hashParts = window?.location?.hash?.split('?');
      if (hashParts?.length) {
        window.history.replaceState({}, '', `${window.location.pathname}${hashParts[0]}`);
      }
      const LoginAzureType = constants.AzureAdType.WORKOSSSO;
      const VerifiedUserModel = {} as VerFiedUserModel;
      VerifiedUserModel.AccessToken = queryParams?.Token as string;
      VerifiedUserModel.username = queryParams?.EmailId;
      VerifiedUserModel.azureAdType = this.checkAzureType(LoginAzureType);
      VerifiedUserModel.isAgilysysEmployee = this.IsAgilysysEmployee;
      const EnpointUrl = '/usermgmt/api/Login/verifyADUser';
      return this.httpservice.postHttpRequest(EnpointUrl, VerifiedUserModel).subscribe(response => {
        if (response) {
          this.adCallBack(response);
        }
      });
    } else if (queryParams?.SSOError) {
        const hashParts = window?.location?.hash?.split('?');
        if (hashParts?.length) {
          window.history.replaceState({}, '', `${window.location.pathname}${hashParts[0]}`);
        }
        this.showPopUp(this._ts.instant('common.error'), queryParams?.SSOError, '', this._ts.instant('common.ok'));
      }
  }

  BindGetUserConfig(response){
    if(!this.commnService.directLogin || (this.commnService.directLogin && sessionStorage.getItem('IsAdUser').toString() == 'true')){
      if(response === 'False'){
        this.commnService.passcodePopupShow.next(true);
        this.commnService.tempPasscodePopupShow.next(true);
        this.commnService.isCreateMessageSubscribe.next(true);
        if(!this.isFromLoadMasterDataComplete)
          this.router.navigate([this.menuList[0].RoutingURL]);
      }
      else{
        if(Number(response) <= (Number(localStorage.getItem('DefaultAlertPeriod')) ?? 5) && Number(response) > 0){
          this.commnService.passcodePopupShow.next(true);
          this.commnService.tempPasscodePopupShow.next(true);
          this.commnService.expiryDays = response;
          this.commnService.isCreateMessageSubscribe.next(false);
          if(!this.isFromLoadMasterDataComplete)
            this.router.navigate([this.menuList[0].RoutingURL]);
        }
        else if(Number(response) <= 0){
          this.commnService.isPasscodeExpiredsubscribe.next(true);
          this.commnService.isCreateMessageSubscribe.next(false);
          this.router.navigate(['/passcode']);
        }
        else{
          this.commnService.passcodePopupShow.next(false);
          this.commnService.tempPasscodePopupShow.next(false);
          this.commnService.isCreateMessageSubscribe.next(false);
          if(!this.isFromLoadMasterDataComplete)
            this.router.navigate([this.menuList[0].RoutingURL]);
        }      
      }
    }   
  }
  checkAndSetActiveAccount() {
    let activeAccount = this.authService.instance.getActiveAccount();
    if (!activeAccount && this.authService.instance.getAllAccounts().length > 0) {
      let accounts = this.authService.instance.getAllAccounts();
      this.authService.instance.setActiveAccount(accounts[0]);
    }
  }
  getClaims(claims: any) {
    try{
    let list: Claim[] = new Array<Claim>();
    Object.keys(claims).forEach(function (k, v) {
      let c = new Claim()
      c.id = v;
      c.claim = k;
      c.value = claims ? claims[k] : null;
      list.push(c);
    });
  } catch(ex) {
    console.log("Exception handled");
  }

  }
  ngAfterViewInit() {
    console.log('sasa')
  }

  /***
 * @Function login 13.2 Modernization
 * @Input UserName and PassWord
 * @output login userdetails
 */
  login = () => {
    this.commnService.directLogin = true;
    this.IsAgilysysEmployee = false;
    if (this.commnService.IsRguest && this.commnService.isonlineStatus) {
      this.rguestLogin();
    } else {
      this.eatecLogin();
    }
  }
  /**
   * @version 13.2 UI
   * @method eatecLogin
   * @input None
   *
   */
  eatecLogin = () => {
    try {
      this.loginError = '';
      const loginDetails = this.loginForm.value;
      this._ml.isSearchAutoComplete = true;
      if (loginDetails.username !== '' && loginDetails.password !== '') {
        this.showLoginError = false;
        this.loginErrorText = ''
        const isTenantActive = this.validateTenantActive();
        if(isTenantActive) {
          if (this.commnService.isonlineStatus) {
            this.apiServiceProviderService.accountService.UserLogin(loginDetails.username,
              loginDetails.password).subscribe(async (data: LoginUserInstances) => {
                this.LoginInstances = data as LoginUserInstances;
                if (this.LoginInstances && !this.LoginInstances.isBlockedUser) {
                  //  && !this.LoginInstances.IsRandomPassword
                  if (this.LoginInstances) {
                    this.defaultInstanceName = this.LoginInstances.EmailId;
                    this.defaultClient_Id = this.LoginInstances.clientId;
                    this.Roles = this.LoginInstances.Roles;
                    this.Sites = this.LoginInstances.Sites;
                    this.ClinetId = this.LoginInstances.clientId;
                    this.loggedInUserId = this.LoginInstances.UserId;
                    this.LanguageCode = this.LoginInstances.LanguageCode;
                    if (this.LoginInstances.SessionId) {
                      localStorage.setItem(constants.EatecSessionId, this.LoginInstances.SessionId);
                    }
                    const GetCurrentLanguage = ( this.LanguageCode !== null ) ? this.LanguageCode : localStorage.getItem(constants.SelectedLanguage)
                    let params= {
                      "UserId": this.loggedInUserId || 0,
                      "LanguageCode": GetCurrentLanguage,
                      "Version": null,
                      "Group": "Mobile"
                  }
                    const apiEndPoint="/usermgmt/api/Login/GetLanguage"
                    this.httpservice.postHttpRequest(apiEndPoint, params).subscribe(x=> {
                      const languageCode = x?.['LanguageCode'];
                      localStorage.setItem(constants.LanguageJson, x['LanguageFile']);
                      localStorage.setItem(constants.CurrentVersion, null);
                      localStorage.setItem(constants.SelectedLanguage, x['LanguageCode'])
                      this.translate.use(languageCode);
                      this.successVerify();
                    },(error) => {
                      const defaultLanJson = 'assets/i18n/en-US.json'
                      this.http.get(defaultLanJson).subscribe(defaultLanguage=> {
                        localStorage.setItem(constants.LanguageJson, JSON.stringify(defaultLanguage));
                        localStorage.setItem(constants.SelectedLanguage, constants.DefaultLanguage);
                        localStorage.setItem(constants.CurrentVersion, null);
                        this.translate.use(constants.DefaultLanguage);
                      this.successVerify();
                      }, (error)=> {
                        this.successVerify();
                      })
                    });    
  
  
                  }
                } 
                // else if (this.LoginInstances?.IsRandomPassword && this.LoginInstances?.PasswordChangePromptOnLogin) {
                //   this.ChangePasswordPopUp();
                // }
                else {
                  this.showPopUp('Error', 'Access Blocked! Please contact administrator to proceed further', '', 'OK');
                }
              },
                err => {
                  const element = err.error as any as LoginErrorEntity;
                  if (!element.Success) {
                    this.loginError = element.Message;
                  }
                }
              );
          } else {
            if(this.commnService.IsRguest && loginDetails.username.toLowerCase() == 'eatec'){
              this.showPopUp(this._ts.instant('common.error'), this._ts.instant('login.invalidUserId'), '', this._ts.instant('common.ok'));
            }
            else{            
              const userObj = {
                username: loginDetails.username,
                password: loginDetails.password,
                componentName: appApiResources.ComponentNameReferences.Login,
                funcName: appApiResources.CSharpCallBackFunctions.LoginResultCallBack,
                Action: cSharpActionName.BindInstance,
                loginCheck : this.IsAdUser && !this.commnService.isonlineStatus,
                LanguageCode: this.LanguageCode
              };
              this.loaderService.isLoading.next(true);
              this.csharpService.RequestGETCSharp(appApiResources.cSharpURLs.GetToken, userObj);
            }
          }
        }
      } else {
        const errorControlKeys: Array<string> = Object.keys(this.loginForm.controls)?.filter(e => this.loginForm.controls[e].errors !== null);
        if (errorControlKeys.length > 0) {
          const errorField = []
          Object.keys(this.loginForm.controls)?.forEach(err => {
            if (this.loginForm.controls[err].errors) {
              errorField.push(this.translate.instant(`login.${err}`));
            }
          });
          if (errorField?.length > 0) {
            this.showLoginError = true;
            const errorString = errorField.map(String).join(' & ');
            this.loginErrorText = this.translate.instant('common.PleaseProvide') + errorString;
          }
        }
        this.loginForm.markAllAsTouched();
      }
    } catch (error) {
      console.error(error);
    }
  }

successVerify(){
  
  sessionStorage.setItem('IsAdUser', this.LoginInstances.IsAdUser.toString());
  if (sessionStorage.hasOwnProperty(appApiResources.loggedInUserId)) {
    sessionStorage.removeItem(appApiResources.loggedInUserId.toString());
  }
  sessionStorage.setItem(appApiResources.loggedInUserId.toString(), this.LoginInstances.UserId.toString());
  if (this.Sites.length > 0) {
    this.locationFrom.controls['site'].setValue(this.Sites[0].Id.toString())
    this.isOneSite = this.Sites.length == 1 ? true : false;
  }
  if (this.Roles.length > 0) {
    this.locationFrom.controls['instance'].setValue(this.Roles[0].Id.toString());
    this.isOneRole = this.Roles.length == 1 ? true : false;
  }
  this.loginType = !this.isOneRole || !this.isOneSite ? 'Location' : 'Login';
  this.showLoginError = this.loginType === 'Location' ? false : this.showLoginError;
  this.loginErrorText = this.loginType === 'Location' ? '' : this.loginErrorText;

  if (this.Sites.length == 1 && this.Roles.length == 1) {
    this.loginLocationClick();
  }
}
  /**
  * @version 13.3 UI;
  * @method validateMobileLicense
  * @input None
  *
  */
  validateMobileLicense(locationPayload: LocationPayloadEntity) {
    try {
      const selectedSiteName = this.Sites.find(i => 
        (i.Id.toString().toLocaleLowerCase() === locationPayload?.SiteId?.toString().toLocaleLowerCase()))?.Name;
      const selectedRoleName = this.Roles.find(i => 
        (i.Id.toString().toLocaleLowerCase() === locationPayload?.RoleId?.toString().toLocaleLowerCase()))?.RoleName;
      const UserDetail = {
        "UserId": this.LoginInstances.UserId,
        "TenantId": localStorage.getItem("TenantId"),
        "DeviceId": localStorage.getItem(appApiResources.DeviceId),
        "DeviceName": localStorage.getItem(appApiResources.DeviceName),
        "SiteName":selectedSiteName,
        "RoleName":selectedRoleName
      }; 
       this.apiServiceProviderService.accountService.ValidateMobileLicense(UserDetail).subscribe((result:any) => {
        if(result){
          localStorage.setItem("activeDeviceDetail",JSON.stringify(result));
          this.getUserAccess(locationPayload);
        }
      }, err => {
        console.log(err);
        this.authentication.logout()
      }
      );
    } catch (error) {
      console.error(error);
    }
  }

  ForgotPassword() {
    if (!this.loginForm.get('username')?.valid) {
      this.showPopUp(this._ts.instant('common.error'), this.translate.instant('login.PleaseProvideUserId'), '', this._ts.instant('common.ok'));
      return;
    }
    const isValidTenant = this.validateTenantActive();
    if(isValidTenant) {
      this.apiServiceProviderService.accountService.ForgotPassword(this.loginForm.value.username).subscribe(async res => {
        this.showPopUp(this._ts.instant('common.Info'), this.translate.instant('login.PasswordSentToMail'), '', this._ts.instant('common.ok'));
      });
    }
  }

  /**
  * @version 13.2 UI;
  * @method rguestLogin
  * @input None
  *
  */
  rguestLogin = () => {
    try {
      this.loginError = '';
      const loginDetails = this.loginForm.value;
      this._ml.isSearchAutoComplete = true;
      if (loginDetails.username !== '' && loginDetails.password !== '') {
        const isTenantActive = this.validateTenantActive();
        if(isTenantActive) {
          if (this.commnService.isonlineStatus) {
            let rguestUrl = '';
            let rguestProductID = '';
            let RGuestTenantCode = '';
            let RGuestTenantId = '';
            if (!this.commnService.rguestLoginUrl) {
              rguestUrl = localStorage.getItem(appApiResources.RguestLoginURL);
              rguestProductID = localStorage.getItem(appApiResources.RGuestProductId);
              RGuestTenantCode = localStorage.getItem(appApiResources.RGuestTenantCode);
              RGuestTenantId = localStorage.getItem(appApiResources.RGuestTenantId);
              this.commnService.rguestLoginUrl = rguestUrl;
              this.commnService.RGuestProductId = rguestProductID;
              this.commnService.RGuestTenantCode = RGuestTenantCode;
              this.commnService.RGuestTenantId = RGuestTenantId ? parseInt(RGuestTenantId) : RGuestTenantId;
            } else {
              rguestUrl = this.commnService.rguestLoginUrl;
            }
  
            const rguestPayload = {} as RguestLoginpayload;
            rguestPayload.UserName = loginDetails.username;
            rguestPayload.Password = loginDetails.password;
            rguestPayload.ProductId = parseInt(this.commnService.RGuestProductId ? this.commnService.RGuestProductId : rguestProductID);
            rguestPayload.TenantCode = this.commnService.RGuestTenantCode
              ? this.commnService.RGuestTenantCode : RGuestTenantCode;
            this.http.post<any>(rguestUrl, rguestPayload).subscribe(x => {
              if (x) {
                this.commnService.rGuestUserName = loginDetails.username;//x.result.userLoginInfo.userName;
                this.commnService.rGuestPassword = loginDetails.password;//x.result.userLoginInfo.password;
                this.commnService.rGuestLoginError = x.errorDescription ?? '';
                if (x.errorCode === 0) {
                  if (!x.result.hasOwnProperty('token'))
                    this.commnService.rGuestLoginError = this.translate.instant('login.InvalidUser');
                  else if (!x.result.userProperties.every((x: any) => x.roleName === 'Inventory Administrator')) {
                    const invalidRoles = (x.result.userProperties.length > 0) ? x.result.userProperties.map(x => x.roleName).toString() : '';
                    this.commnService.rGuestLoginError = this.translate.instant('login.RoleName') + invalidRoles + this.translate.instant('login.notSupported');
                  }
                }
  
                if (this.commnService.IsRguest && this.commnService.rGuestLoginError != null && this.commnService.rGuestLoginError.trim() != '' && x.errorCode != 5001) {
                  const syncObj = {
                    userName: this.commnService.rGuestUserName,
                    password: null,
                    errorDesc: this.commnService.rGuestLoginError,
                    Modulename: appApiResources.cSharpModuleName.UpdateRGuestUser,
                    Action: appApiResources.cSharpActionName.UpdateRGuestUser
                  };
                  this.csharpService.RequestPOSTCSharp(appApiResources.cSharpURLs.UpdateRGuestUser, syncObj);
                }
              }
              if (x && (x.errorCode === 5003 || x.errorCode === 0)) {
                if ((x.errorCode === 0 && x.result.hasOwnProperty('token')) || x.errorCode === 5003) {
                  const accessToken = (x.errorCode === 0 && x.result.hasOwnProperty('token')) ? decodeURIComponent(x.result.token) : '';
                  const decodeToken = (accessToken !== '') ? jwt_decode(accessToken) : null;
                  const MobilePayload = {} as RguestSsoMobilePayload;
                  MobilePayload.token = (x.errorCode === 0) ? x.result.token : '';
                  MobilePayload.username = x.result.userLoginInfo.userName;
                  MobilePayload.IsActive = (x.errorCode === 0) ? true : false;
                  MobilePayload.expirytime = (decodeToken !== null) ? decodeToken['exp'].toString() : '';
                  MobilePayload.Emailid = x.result.userLoginInfo.email;
                  MobilePayload.UserSiteRole = [];
                  let checkTenantId: boolean = true
                  if (x.result.userProperties && x.result.userProperties.length > 0) {
                    checkTenantId = x.result.userProperties.every((x: any) => x.tenantId === this.commnService.RGuestTenantId)
                    const UserSite = x.result.userProperties.map((UserProp: any) => {
                      // tslint:disable-next-line:no-shadowed-variable
                      const UserSite = {} as UserSiteRole;
                      UserSite.Site = UserProp.propertyId;
                      UserSite.Sitename = UserProp.propertyName;
                      UserSite.Rolename = UserProp.roleName;
                      return UserSite;
                    });
                    MobilePayload.UserSiteRole = [...UserSite];
                  }
                  if (checkTenantId) {
                    this.apiServiceProviderService.accountService.UserSsoLogin(MobilePayload).subscribe((LoginData: SSOLoginData) => {
                      if (LoginData) {
                        this.LoginInstances = {} as LoginUserInstances;
                        this.LoginInstances.Locations = LoginData.Locations;
                        this.loginType = 'Location';
                        this.Roles = LoginData.Roles;
                        this.Sites = LoginData.Sites;
                        this.ClinetId = LoginData.clientId;
  
                        this.loggedInUserId = LoginData.UserId;
                        if (sessionStorage.hasOwnProperty(appApiResources.loggedInUserId)) {
                          sessionStorage.removeItem(appApiResources.loggedInUserId.toString());
                        }
                        sessionStorage.setItem(appApiResources.loggedInUserId.toString(), LoginData.UserId.toString());
                        if (this.Sites.length > 0) {
                          this.locationFrom.controls['site'].setValue(this.Sites[0].Id.toString())
                          this.isOneSite = this.Sites.length == 1 ? true : false;
                        }
                        if (this.Roles.length > 0) {
                          this.locationFrom.controls['instance'].setValue(this.Roles[0].Id.toString());
                          this.isOneRole = this.Roles.length == 1 ? true : false;
                        }
                      }
                    });
                  } else {
                    this.showPopUp(this._ts.instant('common.error'), this._ts.instant('login.invalidTenantId'), '', this._ts.instant('common.ok'));
                  }
                } else {
                  this.showPopUp(this._ts.instant('common.error'), this._ts.instant('login.invalidUserId'), '', this._ts.instant('common.ok'));
                }
              } else {
                this.showPopUp(this._ts.instant('common.error'), x.errorDescription, '', this._ts.instant('common.ok'));
              }
            }, err => {
              if (err.status === 404) {
                this.showPopUp(this._ts.instant('common.error'), this._ts.instant('login.Configurationerrormsg'), '', this._ts.instant('common.ok'));
              }
            });
          }
        }
      }

    } catch (error) {
      console.error(error);
    }
  }
  /**
   * @version 13.2 UI
   */
  showPopUp(headerText: any, contentText: any, cancelText: any, confirmText: any, data = null) {
    const dialogArray = {
      headerText: headerText,
      contentText: contentText,
      cancelText: cancelText,
      confirmText: confirmText,
      cancelHelpText: 'CANCEL',
      confirmHelpText: 'CONFIRM'
    };
    this.commnService.mobilePopUpProperty.data = dialogArray;
    this.dialog.open(PopupComponent,
      this.commnService.mobilePopUpProperty
    );
  }

  async ChangePasswordPopUp() {
    this.PasswordComplexityConditionsData = await PasswordComplexityCheck(this.commnService.passwordComplexTenantConfig, this.translate);
    const ConfirmPopUpDialog: AddNewPopModel = {
      PopupHeaderContent: this.translate.instant('Login.ChangePassword'),
      ClassName: 'ChangePassword',
      FormType: 'save',
      CheckPasswordValidation: true,
      PasswordComplexityConditions: this.PasswordComplexityConditionsData,
      SuccessMessage: false,
      EnableSingleButton: false,
      EnableSecondHeader: true
    };
    const dialogRef = this.dialog.open(AgilysysChangePasswordPopupComponent, {
      width: '650px',
      height: '450px',
      data: ConfirmPopUpDialog,
      autoFocus: false,
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result?.value) {
        this.ChangePassword(result);
      }
    });
  }

  ChangePassword(FormData) {
    try {
      const requestObject = {
        userName: this.loginForm.value.username,
        currentPassword: this.loginForm.value.password,
        newPassword: FormData.value.newPassword,
        confirmPassword: FormData.value.confirmPassword
      };

      this.apiServiceProviderService.accountService.ChangePassword(requestObject).subscribe(async res => {
        this.showPopUp(this._ts.instant('common.Success'), res, '', this._ts.instant('common.ok'));
        this.loginForm.controls['password'].setValue('');
      });
    } catch (error) {
      console.error('Error occurred in change password, error = ', error);
    }
  }

  /**
  * @function loginLocationClick 13.1 Modernization
  * @inputParams RoleId, SiteId, ClientId
  * @ouputParams token
  */
  async loginLocationClick() {
    try {
      if (this.locationFrom.value.instance && this.locationFrom.value.instance !== undefined
        && this.locationFrom.value.site && this.locationFrom.value.site !== undefined) {
        const roleId = this.locationFrom.value.instance;
        const siteId = this.locationFrom.value.site;
        this.loggedInSiteId = siteId;
        const selectedSite = this.Sites.find(i => (i.Id.toString().toLocaleLowerCase() === siteId.toString().toLocaleLowerCase()));
        const siteName = selectedSite.Name;
        this._sessionStorage.SessionSetItem(appApiResources.loggedInSiteFullName.toString(), siteName);
        sessionStorage.setItem(appApiResources.loggedInSiteFullName.toString(), siteName);
        sessionStorage.setItem(appApiResources.loggedInDecimalViewValue.toString(), selectedSite.NumericDecimalPlace != null ? selectedSite.NumericDecimalPlace?.ConfigureValue?.toString() : '4');
        sessionStorage.setItem(appApiResources.loggedInCurrencyViewValue.toString(), selectedSite.CurrencyDecimalPlace != null ? selectedSite.CurrencyDecimalPlace?.ConfigureValue?.toString() : '4');
        localStorage.setItem(appApiResources.TimeZone, (selectedSite['SiteTimeZone']?.IanaTimezone || appApiResources.DefaultTimeZone));
        localStorage.setItem(appApiResources.UserTimeZone, (selectedSite['SiteTimeZone']?.TimeZone || appApiResources.DefaultUserTimeZone));
        localStorage.setItem(appApiResources.TimezoneDescription, (selectedSite['SiteTimeZone']?.Description ? 
          `${selectedSite['SiteTimeZone']?.Description} ${selectedSite['SiteTimeZone']?.UTC}` : ''));
        CommonService.decimalvisibleLength = selectedSite.NumericDecimalPlace?.ConfigureValue ?? 4;
        this.commnService.currencyvisibleLength = selectedSite.CurrencyDecimalPlace?.ConfigureValue ?? 4;
        this.defaultSiteName = siteName.indexOf('(') === -1 ? siteName.substring(0) : siteName.substring(0, siteName.indexOf('('));
        const siteAbbreviation = this.findSiteAbbreviation(siteName);
        this.siteAbb = siteAbbreviation;
        sessionStorage.setItem(appApiResources.loggedInSiteId.toString(), siteId);
        this._sessionStorage.SessionSetItem(appApiResources.loggedInSiteName.toString(), siteName);
        this._sessionStorage.SessionSetItem(appApiResources.loggedInSiteAbbreviation.toString(), siteAbbreviation);
        this.commnService.siteAbbreviation = siteAbbreviation;
        const locationPayload = {} as LocationPayloadEntity;
        locationPayload.RoleId = roleId;
        locationPayload.SiteId = siteId;
        locationPayload.ClientId = encodeURIComponent(this.ClinetId);
        if (this.commnService.isonlineStatus) {
          this.validateMobileLicense(locationPayload);
          //this.NevigateToInventory();
        }
        else {
          const userAccessObj = {
            roleId: roleId,
            userId: this.loggedInUserId,
            componentName: appApiResources.ComponentNameReferences.Login,
            funcName: appApiResources.CSharpCallBackFunctions.UserAccess,
            Action: cSharpActionName.BindInstance
          };
          this.csharpService.RequestGETCSharp(appApiResources.cSharpURLs.GetUserAccess, userAccessObj);

          const Currencies = {
              componentName: appApiResources.ComponentNameReferences.Login,
              funcName: appApiResources.CSharpCallBackFunctions.BindGetCurrencies,
              Action: cSharpActionName.GetCurrencies,
              LookupName: null
            };
            this.csharpService.RequestGETCSharp(appApiResources.cSharpURLs.GetSources, Currencies);
        }
      } else {

        const errorControlKeys: Array<string> = Object.keys(this.locationFrom.controls)?.filter(e => this.locationFrom.controls[e].errors !== null);
        if (errorControlKeys.length > 0) {
          const errorField = []
          Object.keys(this.locationFrom.controls)?.forEach(err => {
            if (this.locationFrom.controls[err].errors) {
              errorField.push(this.translate.instant(`login.${err}`));
            }
          });
          if (errorField?.length > 0) {
            this.showLoginError = true;
            const errorString = errorField.map(String).join(' & ');
            this.loginErrorText = this.translate.instant('common.PleaseProvide') + errorString;
          }
        }
        this.locationFrom.markAllAsTouched();
        // if (!this.locationFrom.value.instance) {
        //   this.locationFrom.controls['instance'].setErrors({ 'incorrect': true });
        //   this.locationFrom.controls['instance'].markAsTouched();
        // }
        // if (!this.locationFrom.value.site) {
        //   this.locationFrom.controls['site'].setErrors({ 'incorrect': true });
        //   this.locationFrom.controls['site'].markAsTouched();
        // }
      }
    } catch (error) {
      console.error(error);
    }
  }
  async getUserAccess(locationPayload: LocationPayloadEntity) {
    try {
      const GetUserAccessData = await this.apiServiceProviderService.accountService.UserAccess(locationPayload).toPromise();
      if (GetUserAccessData) {
        window.localStorage.setItem('AuthorizationData', GetUserAccessData);
        const previlegeModal: AuthorizationConfig = {
          previlege: JSON.parse(GetUserAccessData),
          previlegeModule: appApiResources.previlgeModule.Inventory
        };
        this.previlegeAuthorizationService.previlgeConfig = previlegeModal;
      }
      this.odataConfigurationService.GetOdataGlobalCollection();

      const GetClientToken = await this.apiServiceProviderService.accountService.GetAuthClientId(locationPayload).toPromise();
      const systemConfig = JSON.parse(localStorage.getItem('systemConfig'));
      let cidData =  this.commnService.SystemConfig?.Cid ? this.commnService.SystemConfig?.Cid : systemConfig?.Cid || null;
      let csinfoData =  this.commnService.SystemConfig?.CSInfo ? this.commnService.SystemConfig?.CSInfo : systemConfig?.CSInfo || null;
      const GetTokenData = await this.apiServiceProviderService.accountService.GetTokenByClientId(GetClientToken,cidData,csinfoData).toPromise();
      const decodeToken: TokenUserAccessEntity = jwt_decode(GetTokenData.access_token);
      const UserInformation = {} as UserInfoEntity;
      UserInformation.Email = decodeToken.EmailId;
      UserInformation.UserName = decodeToken.username;
      UserInformation.UserId = parseInt(decodeToken.userid);
      UserInformation.GroupId = "1";
      UserInformation.Id = this.LoginInstances.UserId;
      this.UserInfo = UserInformation;
      if (this.UserInfo) {
        this.usertoken = decodeToken;
        // set client details & clientId to localstorage
        localStorage.setItem(appApiResources.LoggedInClientId, this.ClinetId);
        localStorage.setItem(appApiResources.instanceName, this.locationFrom.value.instance);
        sessionStorage.setItem(appApiResources.userInfo, JSON.stringify(UserInformation));
        if (sessionStorage.hasOwnProperty(appApiResources.loggedInUserId)) {
          sessionStorage.removeItem(appApiResources.loggedInUserId.toString());
        }
        sessionStorage.setItem(appApiResources.loggedInUserId.toString(), JSON.stringify(UserInformation.UserId));
        // this.commnService.IsRguest = (decodeToken.hasOwnProperty('rGuestUser') && decodeToken['rGuestUser'] === 'true') ? true : false;
        const GetLocationUrl = this.requestService.contractractLocUrl();
        const GetLoggedInLocation = await this.setupService.GetLoggedInLocation(GetLocationUrl).toPromise();
        // const userJson = JSON.parse(UserInfo.value);
        let GetLoggedLoctionIds = [];
        if (GetLoggedInLocation && GetLoggedInLocation.hasOwnProperty('value') && GetLoggedInLocation.value.length > 0 && this.LoginInstances.hasOwnProperty('Locations')) {
          if (this.loggedInSiteId != 1) {
            GetLoggedLoctionIds = GetLoggedInLocation.value.filter(( Id ) => this.LoginInstances.Locations.some(exclude => exclude.Id == Id.Id)).map((x: any) => x.Id);
          }
          if (GetLoggedLoctionIds.length == 0) {
            GetLoggedLoctionIds = GetLoggedInLocation.value.map((x: any) => x.Id);
          }
          // const GetLoggedLoctionIds = GetLoggedInLocation.value.map((x: any) => x.Id);
          this._sessionStorage.SessionSetItem(appApiResources.loggedInLocationId.toString(), GetLoggedLoctionIds);
        }
        const GetSystemPreference = await this.setupService.GetSystemPrefrences('/0').toPromise();
        const globalSystemPreferenceArray: Array<any> = [];
        const systemPreference = GetSystemPreference['value'];//GetSystemPreference['SystemPreferences'];
        let sysprefJSON = GetSystemPreference.value.length ? JSON.parse(systemPreference) : '';
        if (sysprefJSON && sysprefJSON?.SystemPreferences && sysprefJSON?.SystemPreferences?.length > 0) {
          sysprefJSON?.SystemPreferences?.forEach((element: any) => {
            const preference = element.SystemPreferences;
            if (preference && preference.length > 0) {
              preference.forEach((preferenceobj: any) => {
                const globalSystemPreference = {} as any;
                globalSystemPreference.Id = preferenceobj.Id;
                globalSystemPreference.GroupName = preferenceobj.GroupName;
                globalSystemPreference.InputType = preferenceobj.InputType;
                globalSystemPreference.IsActive = preferenceobj.IsActive;
                globalSystemPreference.LookupName = preferenceobj.LookupName;
                globalSystemPreference.LookupValue = preferenceobj.LookupValue;
                globalSystemPreferenceArray.push(globalSystemPreference);
              });
            }
          });
        }
        this.GlobalConversionService.globalSystemPreference = globalSystemPreferenceArray;

        const paramsQuery: QueryParams = {
          count: true,
          top: 1,
          skip: 0,
          expand: '',
          select: 'EndDate',
          filter: '',
          orderby: 'EndDate desc',
          isactive: true,
          search: '',
          filterQuery: 'FinancialStatusId eq 2 and IsActive eq true',
          searchtext: ''
        };
        const requestParams: any = this.requestService.constractRequestParams(paramsQuery);
        if (!this.commnService.IsRguest) {
          await this.apiServiceProviderService.setupService.GetFinancialPeriods(requestParams).toPromise().then(data => {
            if (data && data.hasOwnProperty('value') && data.value.length > 0) {
              this.GlobalConversionService.closedFinancialPeriodDate = moment(data.value[0].EndDate).format();
            }
          });
        }

        const siteParams: QueryParams = {
          count: true,
          expand: 'SitesBaseCurrency',
          // select: '',
          // filter: '',
          // orderby: 'EndDate desc',
          isactive: true,
          search: '',
          filterQuery: `Id eq (${1})`,
          searchtext: ''
        };
        const params: any = this.requestService.constractRequestParams(siteParams);
        const siteData = await this.apiServiceProviderService.setupService.GetSites(params).toPromise();
        sessionStorage.setItem('BaseCurrencyId', siteData.value[0].BaseCurrencyId);

        const currencies = await this.apiServiceProviderService.setupService.Getcurrencies().toPromise();
        this.commnService.Currencies = currencies;
        //sessionStorage.setItem('Currencies', JSON.stringify(currencies.ResultData));

        this.loadNavigationMenu();
      }
    } catch (error) {
      console.error(error);
    }
  }

  BindGetCurrencies(response){
    if(response){
      this.commnService.Currencies = response.Currency;
      this.GlobalConversionService.closedFinancialPeriodDate = response.FinancialPeriodDate;
      sessionStorage.setItem('BaseCurrencyId', response.BaseCurrencyId);

      const globalSystemPreferenceArray: Array<any> = [];
      if (response && response.SystemPreference && response.SystemPreference.length > 0) {
        response.SystemPreference.forEach((preferenceobj: any) => {
          const globalSystemPreference = {} as any;
          globalSystemPreference.Id = preferenceobj.Id;
          globalSystemPreference.IsActive = preferenceobj.IsActive;
          globalSystemPreference.LookupName = preferenceobj.LookupName;
          globalSystemPreference.LookupValue = preferenceobj.LookupValue;
          globalSystemPreferenceArray.push(globalSystemPreference);
        });
      }
      this.GlobalConversionService.globalSystemPreference = globalSystemPreferenceArray;

    }
    const FinancialObj = {
      componentName: appApiResources.ComponentNameReferences.Login,
      funcName: appApiResources.CSharpCallBackFunctions.GetClosedFinancialPeriodDateCallBack,
      Action: cSharpActionName.GetClosedFinancialPeriodDate
    };
    this.csharpService.RequestGETCSharp(appApiResources.cSharpURLs.GetSources, FinancialObj);        
  }

  SaveDeviceInformation(responseObj) {
    localStorage.setItem(appApiResources.DeviceId, responseObj.DeviceId);
    localStorage.setItem(appApiResources.DeviceName, responseObj.DeviceName);
    localStorage.setItem(appApiResources.DeviceType, responseObj.DeviceType);
    localStorage.setItem(appApiResources.HasCamera, responseObj.HasCamera);
    localStorage.setItem('apiUrl', responseObj.ApiUrl);
    this.commnService.apiUrl = responseObj.ApiUrl;
    this.apiUrl = responseObj.ApiUrl;
    this.csharpService.IsLoadFromApp = true;
  }

  setDefaultLanguage = () => {
    const availableLanguage = this.authentication.getUserLanguage();
    availableLanguage ? this.translate.use(availableLanguage) : this.translate.use('en');
  }

  LoginResult = (responseObj) => {
    this.loaderService.isLoading.next(false);
    if (!responseObj.IsAuthenticated) {
      this.BindErrorMsg(responseObj);
    } else {
      this.BindInstances(responseObj);
    }
  }

  getSitesByClientId = async (InstanceName, Client_Id) => {
    if (this.commnService.isonlineStatus) {
      const _that = this;
      const systemConfig = JSON.parse(localStorage.getItem('systemConfig'));
      let cidData =  _that.commnService.SystemConfig?.Cid ? _that.commnService.SystemConfig?.Cid : systemConfig?.Cid || null;
      let csinfoData =  _that.commnService.SystemConfig?.CSInfo ? _that.commnService.SystemConfig?.CSInfo : systemConfig?.CSInfo || null;
      this.apiServiceProviderService.accountService.GetTokenByClientId(Client_Id,cidData,csinfoData).subscribe((data: any) => {
        if ( data?.access_token) {
          this.usertoken = data.access_token;
          this.SelectedInstance = InstanceName;
          this.ClientId = Client_Id;
          localStorage.setItem(appApiResources.LoggedInClientId, Client_Id);
          const decodeToken = jwt_decode(data.access_token);
          const decodeObject = JSON.parse(decodeToken['Privileges']);
          if (decodeToken['rGuestUser'] !== undefined) {
            // this.commnService.IsRguest = decodeToken['rGuestUser'] === 'true';
            this.commnService.IsRguest = false;
          } else {
            this.commnService.IsRguest = false;
          }
          decodeObject['rGuestUser'] = this.commnService.IsRguest;
          if (decodeObject !== null) {
            const previlegeModal: AuthorizationConfig = {
              previlege: decodeObject,
              previlegeModule: appApiResources.previlgeModule.Inventory
            };
            this.previlegeAuthorizationService.previlgeConfig = previlegeModal;
            localStorage.setItem(appApiResources.userPrivileges, JSON.stringify(decodeObject));
            this.previlegeAuthorizationService._authorizationInfo = decodeObject;
            this.previlegeAuthorizationService.getAuthorizationMenu(decodeObject);
          }
        }

        this.apiServiceProviderService.accountService.GetUserInformation().subscribe(result => {
          this.UserInfo = result as UserInfoEntity;
          this.Sites = this.UserInfo.ListSites; //  result as SiteEntity[];
          if (this.Sites && this.Sites.length > 0) {
            _that.locationFrom.controls['site'].markAsUntouched();
            this.defaultSiteId = this.Sites[0].Id;
            _that.locationFrom.controls['site'].setValue(this.defaultSiteId);
            if (this.Instances.length > 1 || this.Sites.length > 1) {
              this.loginType = 'Location';
              this.showSettingsicon = false;
            } else {
              _that.locationFrom.controls['instance'].setValue(this.Instances[0].Name);
              this.showSettingsicon = false;
            }
          }
          this.GetEatecGlobalSettings();
        });
      },
        err => {
          this.loginType = 'Location';
          this.showSettingsicon = false;
          _that.locationFrom.controls['site'].setErrors({ 'incorrect': true, 'focused': false });
          _that.locationFrom.controls['site'].markAsTouched();
          _that.loginError = _that._ts.instant('login.siteNotFound');
          _that.Sites = [];
          // let siteDiv = document.getElementsByClassName('site')[0];
          // siteDiv.getElementsByClassName('mat-form-field-label')[0]['style'].display = 'block';
        }
      );
    } else {
      const userObj = {
        instancename: InstanceName,
        UserName: this.UserInfo.UserName,
        componentName: appApiResources.ComponentNameReferences.Login,
        funcName: appApiResources.CSharpCallBackFunctions.GetSiteCallBack,
        Action: cSharpActionName.BindSites
      };
      this.csharpService.RequestGETCSharp(appApiResources.cSharpURLs.GetSites, userObj);
    }
  }
  BindErrorMsg = (errorObj) => {
    // this.loginError = errorObj.error_description;
    this.loginError = this._ts.instant('common.' + errorObj.error_description);
    console.log('this.loginError ', this.loginError);
    this.showPopUp(this._ts.instant('common.error'), errorObj.error_description, '', this._ts.instant('common.ok'));
  }

  async SaveUserDeviceInformation() {
    const UserDeviceEntity = {} as UserLicenceDetailsEntity;
    const siteId = sessionStorage.getItem(appApiResources.loggedInSiteId);
    const siteName = sessionStorage.getItem(appApiResources.loggedInSiteFullName);
    const deviceId = localStorage.getItem(appApiResources.DeviceId);
    const deviceName = localStorage.getItem(appApiResources.DeviceName);
    const deviceType = localStorage.getItem(appApiResources.DeviceType);
    const userData = JSON.parse(sessionStorage.getItem(appApiResources.userInfo));
    // UserDeviceEntity.LoginTime = moment().format(); //commented to take login time in server itself.
    // UserDeviceEntity.usertoken = this.usertoken;
    UserDeviceEntity.SiteId = Number(siteId);
    UserDeviceEntity.SiteName = siteName;
    UserDeviceEntity.UserId = userData.UserId;
    UserDeviceEntity.DeviceId = deviceId;
    UserDeviceEntity.DeviceName = deviceName;
    UserDeviceEntity.DeviceType = deviceType;
    UserDeviceEntity.UserName = userData.UserName;
    UserDeviceEntity.UserMailId = userData.Email;
    UserDeviceEntity.UserGroup = userData.GroupId;

    await this.apiServiceProviderService.licencingService.SaveUserInformation(UserDeviceEntity).toPromise();
  }

  BindInstances = (responseObj) => {
    this.loginType = 'Location';
    var LoginInstances = responseObj as LoginUserInstances;
    if (LoginInstances) {
      this.defaultInstanceName = LoginInstances.EmailId;
      this.Roles = LoginInstances.Roles;
      this.Sites = LoginInstances.Sites;
      this.loggedInUserId = LoginInstances.UserId;
      this.ClinetId = LoginInstances?.clientId || LoginInstances?.ClientId;
      this.LoginInstances = LoginInstances;
      if (this.Sites.length > 0) {
        this.locationFrom.controls['site'].setValue(this.Sites[0].Id.toString())
        this.isOneSite = this.Sites.length == 1 ? true : false;
      }
      if (this.Roles.length > 0) {
        this.locationFrom.controls['instance'].setValue(this.Roles[0].Id.toString());
        this.isOneRole = this.Roles.length == 1 ? true : false;
      }
      if (!this.commnService.IsRguest) {
        this.loginType = !this.isOneRole || !this.isOneSite ? 'Location' : 'Login';

        if (this.Sites.length == 1 && this.Roles.length == 1) {
          this.loginLocationClick();
        }
      }
    }
  }

  UserAccess = (responseObj) => {
    if (responseObj == null) {
      this.BindErrorMsg(responseObj);
    } else {
      if (responseObj) {
        var userAccess = responseObj as UserData;
        window.localStorage.setItem('AuthorizationData', JSON.stringify(userAccess.AuthorizationData));
        const previlegeModal: AuthorizationConfig = {
          previlege: userAccess.AuthorizationData,
          previlegeModule: appApiResources.previlgeModule.Inventory
        };
        this.previlegeAuthorizationService.previlgeConfig = previlegeModal;
      }
      const UserInfo = userAccess.UserInfo;
      const convertUserInfo = (typeof UserInfo === 'string') ? JSON.parse(UserInfo) : UserInfo;
      this.UserInfo = convertUserInfo;
      localStorage.setItem(appApiResources.instanceName, this.locationFrom.value.instance);
      sessionStorage.setItem(appApiResources.userInfo, JSON.stringify(convertUserInfo));
      sessionStorage.setItem(appApiResources.loggedInUserId.toString(), JSON.stringify(this.UserInfo.UserId));
      sessionStorage.setItem(appApiResources.loggedInUserName.toString(), JSON.stringify(this.UserInfo.UserName));

      this.loggedInUserId = this.UserInfo.UserId;
      this.loggedInUserName = this.UserInfo.UserName;

      if (this.csharpService.IsLoadFromApp) {
        const ODatasourceObj = {
          componentName: appApiResources.ComponentNameReferences.Login,
          funcName: appApiResources.CSharpCallBackFunctions.GetODataCollection,
          Action: appApiResources.cSharpActionName.GetODataCollection
        };
        this.csharpService.RequestGETCSharp(appApiResources.cSharpURLs.GetODataCollection, ODatasourceObj);
      }

      if (this.csharpService.IsLoadFromApp) {
        const sourceObj = {
          siteId: this.loggedInSiteId,
          userId: this.loggedInUserId,
          sites: JSON.stringify(this.Sites),
          componentName: appApiResources.ComponentNameReferences.Login,
          funcName: appApiResources.CSharpCallBackFunctions.GetSiteLocationIds,
          Action: appApiResources.cSharpActionName.GetSiteLocationIds
        };
        this.csharpService.RequestGETCSharp(appApiResources.cSharpURLs.GetSiteLocationIds, sourceObj);
      }
    }
  }

  GetODataCollection = (responseObj) => {
    if (responseObj == null) {
      this.BindErrorMsg(responseObj);
    } else {
      if (responseObj) {
        this.odataConfigurationService.OdataCollection = JSON.parse(responseObj);
      }
    }
  }

  GetSiteLocationIds = (responseObj) => {
    if (responseObj == null) {
      this.BindErrorMsg(responseObj);
    } else {
      if (responseObj) {
        this._sessionStorage.SessionSetItem(appApiResources.loggedInLocationId.toString(), responseObj);
      }

      this.loadNavigationMenu();
    }
  }

  storeUserInfoLocalStore = (responseObj) => {
    if (responseObj.Privilege && responseObj.Privilege !== '') {
      const decodeToken = jwt_decode(responseObj.Privilege);
      const decodeObject = JSON.parse(decodeToken['Privileges']);
      // Based on this 363269 Eatec Mobile Not Supported In IC
      //this.commnService.IsRguest = decodeObject['IsRguest'];
      this.commnService.IsRguest = false;
      if (decodeObject !== null) {
        const previlegeModal: AuthorizationConfig = {
          previlege: decodeObject,
          previlegeModule: appApiResources.previlgeModule.Inventory
        };
        if (localStorage.hasOwnProperty(appApiResources.userPrivileges)) {
          localStorage.removeItem(appApiResources.userPrivileges);
        }
        this.previlegeAuthorizationService.previlgeConfig = previlegeModal;
        localStorage.setItem(appApiResources.userPrivileges, JSON.stringify(decodeObject));
      }
    }
    if (responseObj.userInfo !== null) {
      this.UserInfo = responseObj.userInfo as UserInfoEntity;

      if (sessionStorage.hasOwnProperty(appApiResources.userInfo)) {
        sessionStorage.removeItem(appApiResources.userInfo);
      }
      sessionStorage.setItem(appApiResources.userInfo, JSON.stringify(this.UserInfo));

      if (sessionStorage.hasOwnProperty(appApiResources.loggedInUserId)) {
        sessionStorage.removeItem(appApiResources.loggedInUserId.toString());
      }
      sessionStorage.setItem(appApiResources.loggedInUserId.toString(), JSON.stringify(this.UserInfo.UserId));

      if (sessionStorage.hasOwnProperty(appApiResources.loggedInUserName)) {
        sessionStorage.removeItem(appApiResources.loggedInUserName.toString());
      }
      sessionStorage.setItem(appApiResources.loggedInUserName.toString(), JSON.stringify(this.UserInfo.UserName));

      localStorage.setItem(appApiResources.loggedInUserlanguage.toString(), this.UserInfo.UserLanguage);
      this.commnService.userAbbreviation = this.findSiteAbbreviation(this.UserInfo.UserName);
      this.setDefaultLanguage();
    }
  }
  async getLocationAndSupplier() {
    await this.getloggedInDetails();
  }
  async getloggedInDetails() {
    if (sessionStorage.hasOwnProperty(appApiResources.loggedInSiteId.toString())) {
      this.loggedInSiteId = await parseInt(sessionStorage.getItem(appApiResources.loggedInSiteId.toString()));
    }
    if (sessionStorage.hasOwnProperty(appApiResources.loggedInUserId.toString())) {
      this.loggedInUserId = await parseInt(sessionStorage.getItem(appApiResources.loggedInUserId.toString()));
    }
    if (sessionStorage.hasOwnProperty(appApiResources.loggedInUserName.toString())) {
      this.loggedInUserName = await sessionStorage.getItem(appApiResources.loggedInUserName.toString());
    }
  }

  BindGetReceivingLocations(response) {
    const locationNameType = appApiResources.ReceivingLocation;
    if (response) {
      localStorage.setItem(locationNameType, JSON.stringify(response));
    }
  }
  BindSupplierDetails(response) {
    const receivingSupplierList = appApiResources.ReceivingSupplierList;
    if (response) {
      localStorage.setItem(receivingSupplierList, JSON.stringify(response));
    }
  }
  BindSites = (siteListObj) => {

    const _that = this;
    if (siteListObj.hasOwnProperty('userInfo')) {
      this.storeUserInfoLocalStore(siteListObj);
      this.GetEatecGlobalSettingsFromLocal();
      this.GetEatecMenuFromLocal();
    }

    if (siteListObj.hasOwnProperty('siteList')) {
      this.Sites = siteListObj.siteList as SiteEntity[];
      if (this.Sites && this.Sites.length > 0) {
        _that.locationFrom.controls['site'].markAsUntouched();
        this.defaultSiteId = this.Sites[0].Id;
        if (this.defaultSiteId >= 0) {
          if (sessionStorage.hasOwnProperty(appApiResources.loggedInSiteId)) {
            sessionStorage.removeItem(appApiResources.loggedInSiteId.toString());
          }
          if (sessionStorage.hasOwnProperty(appApiResources.loggedInSiteName)) {
            sessionStorage.removeItem(appApiResources.loggedInSiteName.toString());
            sessionStorage.removeItem(appApiResources.loggedInSiteFullName.toString());
          }
          if (sessionStorage.hasOwnProperty(appApiResources.loggedInSiteAbbreviation)) {
            sessionStorage.removeItem(appApiResources.loggedInSiteAbbreviation.toString());
          }

          _that.defaultSiteName = _that.Sites.find(i => (i.Id.toString() === _that.defaultSiteId.toString())).Name;

          sessionStorage.setItem(appApiResources.loggedInSiteFullName.toString(), this.defaultSiteName);
          _that.defaultSiteName = _that.defaultSiteName.indexOf('(') === -1 ? _that.defaultSiteName.substring(0) :
            _that.defaultSiteName.substring(0, _that.defaultSiteName.indexOf('('));

          _that.defaultSiteAbbreviation = this.findSiteAbbreviation(_that.defaultSiteName);


          sessionStorage.setItem(appApiResources.loggedInSiteId.toString(), JSON.stringify(this.defaultSiteId));
          sessionStorage.setItem(appApiResources.loggedInSiteName.toString(), this.defaultSiteName);
          sessionStorage.setItem(appApiResources.loggedInSiteAbbreviation.toString(), this.defaultSiteAbbreviation);
          _that.commnService.siteAbbreviation = this.defaultSiteAbbreviation;
        }
      } else {
        _that.locationFrom.controls['site'].setErrors({ 'incorrect': true, 'focused': false });
        _that.locationFrom.controls['site'].markAsTouched();
        _that.loginError = _that._ts.instant('login.siteNotFound');
        const siteDiv = document.getElementsByClassName('site')[0];
        siteDiv.getElementsByClassName('mat-form-field-label')[0]['style'].display = 'block';
      }
    }

  }



  findSiteAbbreviation = (siteName) => {
    let siteAbb: any;
    this.siteAbb = null;
    const format = new RegExp(/[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/);
    if (siteName !== undefined && siteName.length > 0) {
      const upperCaseLetters = siteName.match(/[A-Z]/g);
      if (upperCaseLetters !== null) {
        this.siteAbb = upperCaseLetters.join().replace(/,/g, '');
      }

      if (this.siteAbb == null || this.siteAbb.length < 2) {
        this.siteAbb = siteName.substring(0, 1).toUpperCase();
      } else if (this.siteAbb.length > 2) {
        const siteNameArray = siteName.split(' ').filter(function (el) { return el.length !== 0; });
        if (siteNameArray !== undefined && siteNameArray.length > 0) {
          siteNameArray.forEach(function (val, index) {

            if (index < 2) {
              if (!format.test(val)) {
                siteAbb = siteAbb !== undefined ? siteAbb + val.match(/[a-zA-Z0-9]/).join().toUpperCase()
                  : val.match(/[a-zA-Z0-9]/).join().toUpperCase();
              }
            }

          });
        }
        this.siteAbb = siteAbb;
      }

      if (this.siteAbb) {
        this.siteAbb = this.siteAbb.substring(0, 2).toUpperCase();
      }
    }
    return this.siteAbb || 'NA';
  }

  loadDashboard = (event) => {
    const siteId = Number(event.target.value);
    const _that = this;
    if (sessionStorage.hasOwnProperty(appApiResources.loggedInSiteId)) {
      sessionStorage.removeItem(appApiResources.loggedInSiteId.toString());
    }

    if (sessionStorage.hasOwnProperty(appApiResources.loggedInSiteName)) {
      sessionStorage.removeItem(appApiResources.loggedInSiteName.toString());
      sessionStorage.removeItem(appApiResources.loggedInSiteFullName.toString());
    }

    if (sessionStorage.hasOwnProperty(appApiResources.loggedInSiteAbbreviation)) {
      sessionStorage.removeItem(appApiResources.loggedInSiteAbbreviation.toString());
    }
    _that.siteName = _that.Sites.find(i => (i.Id.toString() === siteId.toString())).Name;
    sessionStorage.setItem(appApiResources.loggedInSiteFullName.toString(), this.siteName);
    _that.siteName = _that.siteName.indexOf('(') === -1 ? _that.siteName.substring(0) : _that.siteName.substring(0, _that.siteName.indexOf('('));
    _that.siteAbbreviation = this.findSiteAbbreviation(_that.siteName);
    sessionStorage.setItem(appApiResources.loggedInSiteId.toString(), JSON.stringify(siteId));
    sessionStorage.setItem(appApiResources.loggedInSiteName.toString(), this.siteName);
    sessionStorage.setItem(appApiResources.loggedInSiteAbbreviation.toString(), this.siteAbbreviation);
    _that.commnService.siteAbbreviation = this.siteAbbreviation;
    // maintain the site id across site
  }
  locationClick = () => {

    if (this.locationFrom.value.instance !== undefined && this.locationFrom.value.site !== undefined) {
      // this.GetEatecGlobalSettings();
      if (sessionStorage.hasOwnProperty(appApiResources.userInfo)) {
        sessionStorage.removeItem(appApiResources.userInfo);
      }
      sessionStorage.setItem(appApiResources.userInfo, JSON.stringify(this.UserInfo));
      if (sessionStorage.hasOwnProperty(appApiResources.loggedInUserId)) {
        sessionStorage.removeItem(appApiResources.loggedInUserId.toString());
      }
      sessionStorage.setItem(appApiResources.loggedInUserId.toString(), JSON.stringify(this.UserInfo.UserId));
      if (sessionStorage.hasOwnProperty(appApiResources.loggedInUserName)) {
        sessionStorage.removeItem(appApiResources.loggedInUserName.toString());
      }
      if (sessionStorage.hasOwnProperty(appApiResources.loggedInUserlanguage)) {
        sessionStorage.removeItem(appApiResources.loggedInUserlanguage.toString());
      }
      sessionStorage.setItem(appApiResources.loggedInUserlanguage.toString(), this.UserInfo.UserLanguage);

      // sessionStorage.setItem(appApiResources.loggedInUserName.toString(), JSON.stringify(this.UserInfo.UserName));
      sessionStorage.setItem(appApiResources.loggedInUserName.toString(), this.UserInfo.UserName.toString());
      localStorage.setItem(appApiResources.loggedInUserlanguage.toString(), this.UserInfo.UserLanguage);
      this.commnService.userAbbreviation = this.findSiteAbbreviation(this.UserInfo.UserName);
      this.setDefaultLanguage();

      localStorage.setItem(appApiResources.instanceName, this.locationFrom.value.instance);
      // localStorage.setItem("DeviceId", "1234567890");

      if (sessionStorage.hasOwnProperty(appApiResources.loggedInSiteId)) {
        sessionStorage.removeItem(appApiResources.loggedInSiteId.toString());
      }
      if (sessionStorage.hasOwnProperty(appApiResources.loggedInSiteName)) {
        sessionStorage.removeItem(appApiResources.loggedInSiteName.toString());
        sessionStorage.removeItem(appApiResources.loggedInSiteFullName.toString());
      }
      if (sessionStorage.hasOwnProperty(appApiResources.loggedInSiteAbbreviation)) {
        sessionStorage.removeItem(appApiResources.loggedInSiteAbbreviation.toString());
      }

      const siteName = this.Sites.find(i => (i.Id.toString() === this.locationFrom.value.site.toString())).Name;
      sessionStorage.setItem(appApiResources.loggedInSiteFullName.toString(), siteName);
      this.defaultSiteName = siteName.indexOf('(') === -1 ? siteName.substring(0) : siteName.substring(0, siteName.indexOf('('));

      const siteAbbreviation = this.findSiteAbbreviation(siteName);

      sessionStorage.setItem(appApiResources.loggedInSiteId.toString(), this.locationFrom.value.site);
      sessionStorage.setItem(appApiResources.loggedInSiteName.toString(), siteName);
      sessionStorage.setItem(appApiResources.loggedInSiteAbbreviation.toString(), siteAbbreviation);
      this.commnService.siteAbbreviation = siteAbbreviation;
      this.getLocationAndSupplier();
      this.loadUserData();
    }
  }
  SaveUserDeatils(response) {
    if (!response.instanceModel?.IsDataSynced && this.commnService.isonlineStatus) {
      this.LoadMasterData();
    }
    else if(!response.instanceModel.IsDataSynced && !this.commnService.isonlineStatus){
      this.openPopup(this._ts.instant('common.Info'), this._ts.instant('login.validationmsg'), '', this._ts.instant('common.ok'),this._ts.instant('login.dataNotSyncedmsg'));
      this.userValidation = true;
    }
     else {      
      this.NevigateToInventory();
    }
  }
  SaveUserdetailsIntoApp() {
    const loginDetails = this.loginForm.value;
    const userObj = {
      userInfo: this.UserInfo,
      siteId: this.locationFrom.value.site,
      access_Token: this.authentication.getAuthToken(),
      selectedInstance: this.locationFrom.value.instance,
      ApiEndPoint: window.localStorage.getItem('apiUrl'),
      componentName: appApiResources.ComponentNameReferences.Login,
      funcName: appApiResources.CSharpCallBackFunctions.SaveUserDeatilsCallBack,
      Action: cSharpActionName.SaveUserDetails,
      IanaTimezone: localStorage.getItem(appApiResources.TimeZone),
      UserTimeZone: localStorage.getItem(appApiResources.UserTimeZone)
    };
    this.csharpService.RequestPOSTCSharp(appApiResources.cSharpURLs.PostUserDetails, userObj);

  }

  NevigateToInventory() {
    // Based on this 363269 Eatec Mobile Not Supported In IC
    // const IsRguest = this._sessionStorage.localStorageGetItem(appApiResources.IsRguest, true);
    const IsRguest = false;
    if (this.commnService.isonlineStatus && IsRguest && this.commnService.rGuestPassword != null && this.commnService.rGuestPassword.trim() != '') {
      const syncObj = {
        userName: this.UserInfo.UserName,
        password: this.commnService.rGuestPassword,
        errorDesc: null,
        Modulename: appApiResources.cSharpModuleName.UpdateRGuestUser,
        Action: appApiResources.cSharpActionName.UpdateRGuestUser
      };
      this.csharpService.RequestPOSTCSharp(appApiResources.cSharpURLs.UpdateRGuestUser, syncObj);
    }

    const instanceName = localStorage.getItem(appApiResources.instanceName);
    const currentUser = JSON.parse(localStorage.getItem(appApiResources.userSessionName));
    if (currentUser != null) {
      const syncObj = {
        access_Token: currentUser.access_token,
        InstanceName: instanceName,
        UserId: sessionStorage.getItem(appApiResources.loggedInUserId.toString()),
        siteId: sessionStorage.getItem(appApiResources.loggedInSiteId.toString()),
        IanaTimezone: localStorage.getItem(appApiResources.TimeZone),
        SyncType: 'auto', TransactionType: 0, Transcationids: '',
        SyncDataType: 'Sync Transaction data',
        Modulename: appApiResources.cSharpModuleName.SyncMasterdata,
        Action: appApiResources.cSharpActionName.SyncMasterdata
      };
      this.csharpService.RequestGETCSharp(appApiResources.cSharpURLs.Synclocaldata, syncObj);
    }
    // this.router.navigate(['/inventory/inventorylist']);
    this.navigationRedirect();
  }

  LoadMasterData() {
    // this.commnService.OpenProcessingPopUp(this.translate.instant('common.Pleasewait'));
    this.openPopup(this._ts.instant('common.Info'), this._ts.instant('login.dataimportmsg'), '', this._ts.instant('common.ok'), 'Inventory');
    localStorage.setItem('masterDataSynced', 'false');
  }

  isFromLoadMasterDataComplete =false;
  LoadMasterDataComplete() {
    this.commnService.closeProcessingPopUp();
    this.getUserConfig();
    localStorage.setItem('masterDataSynced', 'true');   
    if(!this.commnService.directLogin || (this.commnService.directLogin && sessionStorage.getItem('IsAdUser').toString() == 'true')){
      this.commnService.isMasterSyncComplete = true;
    }
    this.isFromLoadMasterDataComplete = true;   
  }
  getUserDetails() {
    this.apiServiceProviderService.accountService.GetUserInformation().subscribe(result => {
      this.UserInfo = result as UserInfoEntity;
      if (sessionStorage.hasOwnProperty(appApiResources.loggedInUserId)) {
        sessionStorage.removeItem(appApiResources.loggedInUserId.toString());
      }
      sessionStorage.setItem(appApiResources.loggedInUserId.toString(), JSON.stringify(this.UserInfo.UserId));

      if (sessionStorage.hasOwnProperty(appApiResources.loggedInUserName)) {
        sessionStorage.removeItem(appApiResources.loggedInUserName.toString());
      }
      sessionStorage.setItem(appApiResources.loggedInUserName.toString(), JSON.stringify(this.UserInfo.UserName));
    });
  }

  togglePassword(event) {
    this.hidePassword = !this.hidePassword;
    event.preventDefault();
  }

  settings() {
    this.router.navigate(['/settings-configuration']);
  }


  showToastMessage(message: string) {
    this.toastShow = true;
    this.toastMessage = message;
  }
  toastDismissed(event) {
    this.toastShow = false;
    this.toastMessage = '';
  }

  toastAutoDismiss(event) {
    this.toastShow = false;
    this.toastMessage = '';
  }

  ngOnDestroy() {
    this.commnService.IsLoginPage = false;
    this._destroying$.next(undefined);
    this._destroying$.complete();

  }

  async GetEatecGlobalSettings() {
    try {

      // Currency Format
      const style = 'currency';
      let localCurrencyCode = 'USD';
      let minimumCurrencyFractionDigits = 2;
      let maximumCurrencyFractionDigits = 2;
      let minimumCurrencyIntegerDigits = 1;

      // Decimal Number Format
      let minimumDecimalFractionDigits = CommonService.decimalvisibleLength;
      let maximumDecimalFractionDigits = CommonService.decimalvisibleLength;
      let minimumDecimalIntegerDigits = CommonService.decimalwholeNumberLength;

      // Date Format
      let DefaultDateFormat = 'MM/DD/YYYY';


      this.apiServiceProviderService.setupService.GetEatecGlobalSettings('all').subscribe(result => {
        if (result && !result.hasOwnProperty('MessageType')) {

          // EatecPreferenceSettings
          this.apiServiceProviderService.utilityService.EatecPreferenceSettings = result.EatecPreferenceSettings;

          // Local Currency Code
          if (result.EatecINISettings.GeneralFormatsGroupSettings.LocalCurrencyCode
            && result.EatecINISettings.GeneralFormatsGroupSettings.LocalCurrencyCode.length > 0) {
            localCurrencyCode = result.EatecINISettings.GeneralFormatsGroupSettings.LocalCurrencyCode;
          }

          // Currency Format
          const iniCurrencyFormatSetting: string = result.EatecINISettings.GeneralFormatsGroupSettings.TypeFormatCurrency;

          if (iniCurrencyFormatSetting && iniCurrencyFormatSetting.length > 0) {
            const currencyDigits: any[] = iniCurrencyFormatSetting.split('.');

            if (currencyDigits.length > 0) {

              const intergerDigits: string = currencyDigits[0];
              const fractionDigits: string = currencyDigits[1];

              minimumCurrencyIntegerDigits = intergerDigits.length <= 0 ? minimumCurrencyIntegerDigits : intergerDigits.length;
              minimumCurrencyFractionDigits = fractionDigits.length <= 0 ? minimumCurrencyFractionDigits : fractionDigits.length;
              maximumCurrencyFractionDigits = fractionDigits.length <= 0 ? maximumCurrencyFractionDigits : fractionDigits.length;
            }
          }

          // Number Format
          const iniDecimalFormatSetting: string = result.EatecINISettings.GeneralFormatsGroupSettings.TypeFormatDecimal;
          if (iniDecimalFormatSetting && iniDecimalFormatSetting.length > 0) {

            const decimalDigits: any[] = iniDecimalFormatSetting.split('.');

            if (decimalDigits.length > 0) {

              const decimalIntergerDigits: string = decimalDigits[0];
              const decimalFractionDigits: string = decimalDigits[1];

              minimumDecimalIntegerDigits = decimalIntergerDigits.length <= 0 ? minimumDecimalIntegerDigits : decimalIntergerDigits.length;
              minimumDecimalFractionDigits = decimalFractionDigits.length <= 0 ? minimumDecimalFractionDigits
                : decimalFractionDigits.length;
              maximumDecimalFractionDigits = decimalFractionDigits.length <= 0 ? maximumDecimalFractionDigits
                : decimalFractionDigits.length;
            }
          }

          // Date Format
          const iniDateFormatSetting: string = result.EatecINISettings.GeneralFormatsGroupSettings.TypeFormatDate.toUpperCase();
          if (iniDateFormatSetting && iniDateFormatSetting.length > 5) {
            DefaultDateFormat = moment(moment().toDate(), iniDateFormatSetting, true).isValid() === true ? iniDateFormatSetting
              : DefaultDateFormat;
          }

          if (localStorage.hasOwnProperty(appApiResources.decimalFormat)) {
            localStorage.removeItem(appApiResources.decimalFormat);
          }
          if (localStorage.hasOwnProperty(appApiResources.currencyFormate)) {
            localStorage.removeItem(appApiResources.currencyFormate);
          }
          if (localStorage.hasOwnProperty(appApiResources.dateFormate)) {
            localStorage.removeItem(appApiResources.dateFormate);
          }
          localStorage.setItem(appApiResources.decimalFormat.toString(), iniDecimalFormatSetting);
          localStorage.setItem(appApiResources.currencyFormate.toString(), iniCurrencyFormatSetting);
          localStorage.setItem(appApiResources.dateFormate.toString(), DefaultDateFormat);
        }

        // Currency Format
        this.apiServiceProviderService.utilityService.CurrencyFormatter = new Intl.NumberFormat('en-US', {
          style: style,
          currency: localCurrencyCode,
          minimumFractionDigits: minimumCurrencyFractionDigits,
          maximumFractionDigits: maximumCurrencyFractionDigits,
          minimumIntegerDigits: minimumCurrencyIntegerDigits
        });
        this.apiServiceProviderService.utilityService.currncyMaximumFractionDigits = maximumCurrencyFractionDigits;

        if (localStorage.hasOwnProperty(appApiResources.CurrencyCode)) {
          localStorage.removeItem(appApiResources.CurrencyCode);
        }
        localStorage.setItem(appApiResources.CurrencyCode.toString(), localCurrencyCode);

        this.apiServiceProviderService.utilityService.CurrencyFormatterWithOutStyle = new Intl.NumberFormat('en-US', {
          // style: style,
          currency: localCurrencyCode,
          minimumFractionDigits: minimumCurrencyFractionDigits,
          maximumFractionDigits: maximumCurrencyFractionDigits,
          minimumIntegerDigits: minimumCurrencyIntegerDigits
        });


        this.apiServiceProviderService.utilityService.CurrencyCode = localCurrencyCode;
        // Number Format
        this.apiServiceProviderService.utilityService.DecimalFormatter = new Intl.NumberFormat('en-US', {
          minimumFractionDigits: minimumDecimalFractionDigits,
          maximumFractionDigits: maximumDecimalFractionDigits,
          minimumIntegerDigits: minimumDecimalIntegerDigits

        });

        // Date Format
        // this.apiServiceProviderService.utilityService.DateFormat = this.DefaultDateFormat;
        this.apiServiceProviderService.utilityService.DateFormat = DefaultDateFormat;
        if (this.Instances.length === 1 && this.Sites.length === 1) {
          this.locationClick();
        }
      });
    } catch (error) {

    }
  }
  GetEatecGlobalSettingsFromLocal() {
    const typeListObj = {
      componentName: appApiResources.ComponentNameReferences.Login,
      funcName: appApiResources.CSharpCallBackFunctions.GetEatecGlobalSettingsCallBack,
      Action: cSharpActionName.BindEatecGlobalSettings
    };
    this.csharpService.RequestGETCSharp(appApiResources.cSharpURLs.GetSources, typeListObj);
  }
  GetEatecMenuFromLocal() {
    const sourceObj = {
      componentName: appApiResources.ComponentNameReferences.Login,
      funcName: appApiResources.CSharpCallBackFunctions.commonServiceComponentCallBack,
      Action: appApiResources.cSharpActionName.BindEatecMenus, userID: this.UserInfo.UserId
    };
    this.csharpService.RequestGETCSharp(appApiResources.cSharpURLs.GetSources, sourceObj);
  }

  BindEatecGlobalSettings(response) {

    try {
      // Currency Format
      const style = 'currency';
      let localCurrencyCode = 'USD';
      let minimumCurrencyFractionDigits = 2;
      let maximumCurrencyFractionDigits = 2;
      let minimumCurrencyIntegerDigits = 1;

      // Decimal Number Format
      let minimumDecimalFractionDigits = 4;
      let maximumDecimalFractionDigits = 4;
      let minimumDecimalIntegerDigits = 1;

      // Date Format
      let DefaultDateFormat = 'MM/DD/YYYY';

      if (response && !response.hasOwnProperty('MessageType')) {

        // EatecPreferenceSettings
        this.apiServiceProviderService.utilityService.EatecPreferenceSettings = response.EatecPreferenceSettings;

        // Local Currency Code
        if (response.EatecINISettings.GeneralFormatsGroupSettings.LocalCurrencyCode
          && response.EatecINISettings.GeneralFormatsGroupSettings.LocalCurrencyCode.length > 0) {
          localCurrencyCode = response.EatecINISettings.GeneralFormatsGroupSettings.LocalCurrencyCode;
        }

        // Currency Format
        const iniCurrencyFormatSetting: string = response.EatecINISettings.GeneralFormatsGroupSettings.TypeFormatCurrency;

        if (iniCurrencyFormatSetting && iniCurrencyFormatSetting.length > 0) {
          const currencyDigits: any[] = iniCurrencyFormatSetting.split('.');

          if (currencyDigits.length > 0) {

            const intergerDigits: string = currencyDigits[0];
            const fractionDigits: string = currencyDigits[1];

            minimumCurrencyIntegerDigits = intergerDigits.length <= 0 ? minimumCurrencyIntegerDigits : intergerDigits.length;
            minimumCurrencyFractionDigits = fractionDigits.length <= 0 ? minimumCurrencyFractionDigits : fractionDigits.length;
            maximumCurrencyFractionDigits = fractionDigits.length <= 0 ? maximumCurrencyFractionDigits : fractionDigits.length;
          }
        }

        // Number Format
        const iniDecimalFormatSetting: string = response.EatecINISettings.GeneralFormatsGroupSettings.TypeFormatDecimal;
        if (iniDecimalFormatSetting && iniDecimalFormatSetting.length > 0) {

          const decimalDigits: any[] = iniDecimalFormatSetting.split('.');

          if (decimalDigits.length > 0) {

            const decimalIntergerDigits: string = decimalDigits[0];
            const decimalFractionDigits: string = decimalDigits[1];

            minimumDecimalIntegerDigits = decimalIntergerDigits.length <= 0 ? minimumDecimalIntegerDigits : decimalIntergerDigits.length;
            minimumDecimalFractionDigits = decimalFractionDigits.length <= 0 ? minimumDecimalFractionDigits : decimalFractionDigits.length;
            maximumDecimalFractionDigits = decimalFractionDigits.length <= 0 ? maximumDecimalFractionDigits : decimalFractionDigits.length;
          }
        }

        // Date Format
        const iniDateFormatSetting: string = response.EatecINISettings.GeneralFormatsGroupSettings.TypeFormatDate.toUpperCase();
        if (iniDateFormatSetting && iniDateFormatSetting.length > 5) {
          DefaultDateFormat = moment(moment().toDate(), iniDateFormatSetting, true).isValid() === true ? iniDateFormatSetting : DefaultDateFormat;
        }

        if (localStorage.hasOwnProperty(appApiResources.decimalFormat)) {
          localStorage.removeItem(appApiResources.decimalFormat);
        }
        if (localStorage.hasOwnProperty(appApiResources.currencyFormate)) {
          localStorage.removeItem(appApiResources.currencyFormate);
        }
        if (localStorage.hasOwnProperty(appApiResources.dateFormate)) {
          localStorage.removeItem(appApiResources.dateFormate);
        }
        localStorage.setItem(appApiResources.decimalFormat.toString(), iniDecimalFormatSetting);
        localStorage.setItem(appApiResources.currencyFormate.toString(), iniCurrencyFormatSetting);
        localStorage.setItem(appApiResources.dateFormate.toString(), DefaultDateFormat);
      }

      this.apiServiceProviderService.utilityService.CurrencyFormatter = new Intl.NumberFormat('en-US', {
        style: style,
        currency: localCurrencyCode,
        minimumFractionDigits: minimumCurrencyFractionDigits,
        maximumFractionDigits: maximumCurrencyFractionDigits,
        minimumIntegerDigits: minimumCurrencyIntegerDigits
      });
      this.apiServiceProviderService.utilityService.currncyMaximumFractionDigits = maximumCurrencyFractionDigits;

      this.apiServiceProviderService.utilityService.CurrencyFormatterWithOutStyle = new Intl.NumberFormat('en-US', {
        // style: style,
        currency: localCurrencyCode,
        minimumFractionDigits: minimumCurrencyFractionDigits,
        maximumFractionDigits: maximumCurrencyFractionDigits,
        minimumIntegerDigits: minimumCurrencyIntegerDigits
      });
      if (localStorage.hasOwnProperty(appApiResources.CurrencyCode)) {
        localStorage.removeItem(appApiResources.CurrencyCode);
      }
      localStorage.setItem(appApiResources.CurrencyCode.toString(), localCurrencyCode);

      this.apiServiceProviderService.utilityService.CurrencyCode = localCurrencyCode;
      // Number Format
      this.apiServiceProviderService.utilityService.DecimalFormatter = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: minimumDecimalFractionDigits,
        maximumFractionDigits: maximumDecimalFractionDigits,
        minimumIntegerDigits: minimumDecimalIntegerDigits

      });

      // Date Format
      // this.apiServiceProviderService.utilityService.DateFormat = this.DefaultDateFormat;
      this.apiServiceProviderService.utilityService.DateFormat = DefaultDateFormat;

    } catch (error) {

    }
  }

  BindPocketMenu(response) {
    const menuList = [];
    this.commnService.UserDetails = response as ApplicationUserEntity;
    if (this.commnService.UserDetails && this.commnService.UserDetails.UIMenus && this.commnService.UserDetails.UIMenus.length > 0) {
      this.commnService.UserDetails.UIMenus = this.commnService.UserDetails.UIMenus.filter(x => x.RoutingURL !== '/manageLicence');
      this.commnService.UserDetails.UIMenus.forEach(item => {
        menuList.push({
          'name': item.Caption,
          'routerLink': item.RoutingURL,
          'icon': item.Icon,
          'visible': item.Visible,
          'enabled': item.Enabled
        });
      });
      if (menuList && menuList.length > 0) {
        localStorage.setItem('uiMenus', JSON.stringify(menuList));
      }
    }
  }

  /*
   * UI 13.2 modernization
   * @method loadNavigationMenu()
   * @Input params None
   * Description Load User Data
   */
  async loadNavigationMenu() {
    try {
      const navigation: any = this.navigationMenu as any;
      let GetUserMenu: Array<UIMenuEntity> = this.previlegeAuthorizationService.navigationAuthorization(navigation);
      const AuthorizationMenu: Array<UIMenuEntity> = this.previlegeAuthorizationService.navigationAuthorization(navigation);
      if (this.locationFrom.value.site === '1') {
        AuthorizationMenu.map((x: UIMenuEntity) => {
          const nonIntercoMenu = [4];
          const menuIndex = nonIntercoMenu.findIndex(e => e === x.MenuId);
          if (menuIndex > -1) {
            x.Visible = false;
            x.Enabled = false;
          }
          return x;
        });
      }
      GetUserMenu = [...AuthorizationMenu];
      const UserEntity = {} as ApplicationUserEntity;
      UserEntity.UIMenus = GetUserMenu;
      if (GetUserMenu && GetUserMenu.length > 0) {
        localStorage.setItem('uiMenus', JSON.stringify(GetUserMenu));
        localStorage.setItem('selectedSite', this.locationFrom.value.site);
        this.commnService.UserDetails = { ...UserEntity };
        if (this.csharpService.IsLoadFromApp) {
          this.SaveUserdetailsIntoApp();
        } else {
          this.navigationRedirect();
        }
      }
    } catch (error) {
      console.log(error);
    }
  }

  /**
   * @ UI 13.2 Moderniztion
   * @navigationRedirect() {
   */
  menuList :any;
  getUserConfig(){
    const userObj = {
      userId: this.loggedInUserId,
      componentName: appApiResources.ComponentNameReferences.Login,
      funcName: appApiResources.CSharpCallBackFunctions.BindGetUserConfig,
    };
    this.csharpService.RequestGETCSharp(appApiResources.cSharpURLs.GetUserConfig, userObj);
  }
  navigationRedirect() {
    try {
      let routingUrl: string;
      this.commnService.isMasterSyncComplete = localStorage.getItem('masterDataSynced') === 'true' ? true : false;
      // Idle timeout is applied when the router leaves `/login` (see AppComponent NavigationEnd + syncIdleTimeoutFromStoredSession),
      // so ng-idle does not receive InactivityTimeout while the URL still includes `/login` (that would call idle.stop() only).
      if (localStorage.getItem(appApiResources.userSessionName)) {
        this.eatecTokenRefreshService.start();
      }
      if (this.commnService.isonlineStatus) {
        const menus: Array<UIMenuEntity> = this.commnService.UserDetails.UIMenus.filter(y => y.Visible === true && y.Enabled === true);
        this.menuList = menus;
        localStorage.setItem("currentUserNavigationMenus", JSON.stringify(menus));
        if (menus && menus.length > 0) {
          routingUrl = menus[0].RoutingURL;
          this.previlegeAuthorizationService.previlgeConfig.previlegeModule = (menus[0].hasOwnProperty('AuthorizationKey')) ?
            menus[0].AuthorizationKey[0] : null;
          if(localStorage.getItem('masterDataSynced') === 'true' && this.adDataInfo && this.adDataInfo.IsAdEnabled && (!this.commnService.directLogin || (this.commnService.directLogin && sessionStorage.getItem('IsAdUser').toString() == 'true'))){
            this.getUserConfig();
          }
          else{
            this.router.navigate([this.menuList[0].RoutingURL]);
          }
        }
      }
      else {
        const menus: Array<UIMenuEntity> = this.commnService.UserDetails.UIMenus.filter(y => y.Visible === true && y.Enabled === true);
        localStorage.setItem("currentUserNavigationMenus", JSON.stringify(menus));
        if (menus && menus.length > 0) {
          routingUrl = menus[0].RoutingURL;
          this.previlegeAuthorizationService.previlgeConfig.previlegeModule = (menus[0].hasOwnProperty('AuthorizationKey')) ?
            menus[0].AuthorizationKey[0] : null;
          this.router.navigate([routingUrl]);
        }
      }
    } catch (error) {
      console.error(error);
    }
  }

  async loadUserData() {
    const menuList = [];
    if (this.commnService.isonlineStatus) {
      await this.commnService.getUiMenus().then(x => {
        this.redirectToDefaultMenu();
        if (parseInt(sessionStorage.getItem(appApiResources.loggedInSiteId.toString())) === 0) {
          appApiResources.IntercoUnAvailableModules.forEach(element => {
            let temp = '';
            if (element === 'Inventory' || element === 'Retail') {
              temp = 'Inventory';
            } else if (element === 'Pending Approvals') {
              temp = 'Document Approvals';
            } else {
              temp = element;
            }
            if (this.commnService.UserDetails.UIMenus.filter(y => y.Caption.includes(temp))) {
              this.commnService.UserDetails.UIMenus = this.commnService.UserDetails.UIMenus.filter(z => z.Caption !== temp);
            }
          });
        }
        this.commnService.UserDetails.UIMenus.forEach(item => {
          menuList.push({
            'name': item.Caption,
            'routerLink': item.RoutingURL,
            'icon': item.Icon,
            'visible': item.Visible,
            'enabled': item.Enabled
          });
        });
        if (menuList && menuList.length > 0) {
          localStorage.setItem('uiMenus', JSON.stringify(menuList));
        }
      });
    } else {
      if (parseInt(sessionStorage.getItem(appApiResources.loggedInSiteId.toString())) === 0) {
        appApiResources.IntercoUnAvailableModules.forEach(element => {
          let temp = '';
          if (element === 'Inventory' || element === 'Retail') {
            temp = 'Inventory';
          } else if (element === 'Pending Approvals') {
            temp = 'Document Approvals';
          } else {
            temp = element;
          }
          if (this.commnService.UserDetails.UIMenus.filter(y => y.Caption.includes(temp))) {
            this.commnService.UserDetails.UIMenus = this.commnService.UserDetails.UIMenus.filter(z => z.Caption !== temp);
          }
        });
        this.commnService.UserDetails.UIMenus.forEach(item => {
          menuList.push({
            'name': item.Caption,
            'routerLink': item.RoutingURL,
            'icon': item.Icon,
            'visible': item.Visible,
            'enabled': item.Enabled
          });
        });
        if (menuList && menuList.length > 0) {
          localStorage.setItem('uiMenus', JSON.stringify(menuList));
        }
      }
      this.redirectToDefaultMenu();
    }
  }
  redirectToDefaultMenu() {
    let routingUrl: any;
    if (this.commnService.UserDetails.UIMenus && this.commnService.UserDetails.UIMenus.length > 0) {
      if (this.commnService.isonlineStatus) {
        this.SaveUserDeviceInformation().then(x => {
          const menus = this.commnService.UserDetails.UIMenus.filter(y => y.Visible === true && y.Enabled === true);
          if (this.commnService.IsRguest) {
            routingUrl = menus.filter(y => y.RoutingURL === '/physicalInventory')[0].RoutingURL;
            this.previlegeAuthorizationService.previlgeConfig.previlegeModule = menus.
              filter(y => y.RoutingURL === '/physicalInventory')[0].Caption;
            const physcialInventoryIndex = menus.findIndex(z => z.RoutingURL === '/physicalInventory') !== -1
              ? menus.findIndex(z => z.RoutingURL === '/physicalInventory') : 0;
            this.commnService.activeMenuChange.next(physcialInventoryIndex.toString());
            this.commnService.fromNav = true;
          } else {
            routingUrl = menus[0].RoutingURL;
            this.previlegeAuthorizationService.previlgeConfig.previlegeModule = menus[0].Caption;
          }
          const moduleName = this.previlegeAuthorizationService.
            getPrevilageLandingkey(this.translate.instant('uiMenus.' + this.previlegeAuthorizationService.previlgeConfig.previlegeModule));
          const isAccesed = this.previlegeAuthorizationService.findLandingAuthorization(moduleName);
          if (isAccesed) {
            this.router.navigate([routingUrl]);
          } else {
            this.commnService.showAppHeaderChange.next(true);
            this.router.navigate(['/auth-denied']);
          }
        });
      } else {
        const menus = this.commnService.UserDetails.UIMenus.filter(x => x.Visible === true && x.Enabled === true);
        routingUrl = menus[0].RoutingURL;
        this.previlegeAuthorizationService.previlgeConfig.previlegeModule = menus[0].Caption;
        const moduleName = this.previlegeAuthorizationService.
          getPrevilageLandingkey(this.translate.instant('uiMenus.' + this.previlegeAuthorizationService.previlgeConfig.previlegeModule));
        const isAccesed = this.previlegeAuthorizationService.findLandingAuthorization(moduleName);
        if (isAccesed) {
          this.router.navigate([routingUrl]);
        } else {
          this.commnService.showAppHeaderChange.next(true);
          this.router.navigate(['/auth-denied']);
        }
      }

    }
  }

  /***
   * @method Azure AD Authentiaction
   */
  async adLoginClick(): Promise<void> {
    console.log('adLoginClick');
    localStorage.setItem('IsAgilysysEmployee', 'false');
    this.setAzureLoginTypeLocal(this.adDataInfo?.AzureAdType);
    if (this.commnService.isonlineStatus && this.validateTenantActive()) {
      this.commnService.directLogin = false;
      if (this.adDataInfo?.AzureAdType === GlobalConstant.AzureAdType.WORKOSSSO) {
        const BaseUrl = window.localStorage.getItem('apiUrl') || window.location.origin;
        const returnUrl = encodeURIComponent(btoa(window.location.origin + window.location.pathname + window.location.hash));
        const acsUrl = encodeURIComponent(btoa(`${BaseUrl}/usermgmt/auth/callback`));
        window.location.href = `${BaseUrl}/usermgmt/auth/login?tenant=${this.adTenantName}&clientUrl=${returnUrl}&acsUrl=${acsUrl}`;
        return;
      }
      if (this.adDataInfo?.AzureAdType === GlobalConstant.AzureAdType.AZUREADSAML) {
        const BaseUrl = window.localStorage.getItem('apiUrl') || window.location.origin;
        const returnUrl = encodeURIComponent(window.location.origin + window.location.pathname + window.location.hash);
        const acsUrl = encodeURIComponent(`${BaseUrl}/usermgmt/api/saml/acs?tenant=${this.adTenantName}`);
        window.location.href = `${BaseUrl}/usermgmt/api/saml/login?tenant=${this.adTenantName}`
          + `&returnUrl=${returnUrl}&acsUrl=${acsUrl}`;
        return;
      }
      const  msalConfig = GetMSALConfig(this.azureConfig);
      sessionStorage.setItem('azureadconfig', JSON.stringify(msalConfig));
      this.authService.instance = new PublicClientApplication(msalConfig);
      await this.authService.instance.initialize();
      localStorage.setItem('tenant', this.adTenantName);    
       const AdInfo = this.azureConfig.getSettings('AdData');  
      const scope = ( AdInfo && AdInfo.AzureAdType ) ? ['openid'] : ['openid', 'profile', 'User.Read', 'offline_access'];
      this.authService.instance.loginRedirect({ prompt: 'login', scopes: scope });
    }
  }

  /***
   * @method adProductLogin;
   * @input Input None
   * @output None
   * @Description adroduct Login 
   */
   async adProductLogin(): Promise<void> {
    console.log('adProductClick');
    localStorage.setItem('IsAgilysysEmployee', 'true');
    const systemConfig = JSON.parse(localStorage.getItem('systemConfig'));
    const { B2CAuthority, B2CTenant, B2CLoginUserflow, ClientID } = this.commnService.SystemConfig ? this.commnService.SystemConfig : systemConfig;
    const ProductAuthority = (B2CAuthority && B2CTenant && B2CLoginUserflow && ClientID) ? `${B2CAuthority}/${B2CTenant}/${B2CLoginUserflow}` : '';
    if(this.validateTenantActive()){
      if(ProductAuthority) {
      this.setAzureLoginTypeLocal(this.adDataInfo?.AzureAdType);
        if (this.commnService.isonlineStatus) {
          this.commnService.directLogin = false;
          const  msalConfig = GetMSALConfig(this.azureConfig);
          msalConfig.auth.authority = ProductAuthority;
          msalConfig.auth.clientId = ClientID;
          msalConfig.auth.knownAuthorities.push(B2CAuthority);
          sessionStorage.setItem('azureadconfig', JSON.stringify(msalConfig));
          this.authService.instance = new PublicClientApplication(msalConfig);
          await this.authService.instance.initialize();
          localStorage.setItem('tenant', this.adTenantName);    
          this.commnService.adAuthority = ProductAuthority;
          const AdInfo = this.azureConfig.getSettings('AdData');  
          const scope = ( AdInfo && AdInfo.AzureAdType ) ? ['openid'] : ['openid', 'profile', 'User.Read', 'offline_access'];
          this.authService.instance.loginRedirect({ prompt: 'login', scopes: scope });
        }
      } else {
        this.openPopup(this._ts.instant('common.Info'), this._ts.instant('login.userflowmsg'), '', this._ts.instant('common.ok'),this._ts.instant('login.userflow'));
      }
    }  
  }
  
  CallUserAPI(token: any, tenantInformation: TenantInformation) {
    try {
      const LoginAzureType = window.localStorage.getItem('LoginAzureType');
      const VerifiedUserModel = {} as VerFiedUserModel;
      VerifiedUserModel.AccessToken = token as string;
      VerifiedUserModel.username = this.UserEmail;
      VerifiedUserModel.azureAdType = this.checkAzureType(LoginAzureType);
      VerifiedUserModel.isAgilysysEmployee = this.IsAgilysysEmployee;
      const EnpointUrl = '/usermgmt/api/Login/verifyADUser';

      const sourceObj = {
        componentName: appApiResources.ComponentNameReferences.Login,
        funcName: appApiResources.CSharpCallBackFunctions.LoaderStopCallBack,
        Action: appApiResources.cSharpActionName.LoaderStop
      };
      this.csharpService.RequestGETCSharp(appApiResources.cSharpURLs.LoaderStop, sourceObj);

      return this.httpservice.postHttpRequest(EnpointUrl, VerifiedUserModel);
    } catch (error) {
      console.log(error);
    }
  }

  msalConfigFactory(azureAdInfo: AzureAdModel): Configuration {
    const auth = {
      auth: {
        clientId: azureAdInfo.clientID,
        authority: azureAdInfo.authority,
        redirectUri: azureAdInfo.redirectUri,
        knownAuthorities: ['https://agilysysdev.b2clogin.com'],
        navigateToLoginRequestUrl: true,
      },
      cache: {
        cacheLocation: azureAdInfo.cacheLocation,
        storeAuthStateInCookie: false, // set to true for IE 11
      }
    };
    return (auth as Configuration);
  }
  getToken(azureAdInfo: AzureAdModel, azureOAuthSettings: OAuthSettingsConfig, azureData: any): Promise<string | void> {
    let azureType = 'AzureAD';
    if (azureAdInfo) {
      const LoginAzureType = window.localStorage.getItem('LoginAzureType');
      azureType = this.checkAzureType(LoginAzureType);
    }
    if (!this.authenticated) {
      return null;
    }
    // this.getAccessToken(azureType, azureData);
    this.adGetAccessToken(azureType, azureData);
  }
  // Silently request an access token
  getAccessToken(azureType: string = null, azureData: any) {
    this.userAgentApp.acquireTokenSilent(this.azureInfoService.azureOAuthSettings).then(result => {
      if (result && result !== undefined && typeof result === 'object' &&
        (result.hasOwnProperty('accessToken') || result.hasOwnProperty('idToken'))) {
        const resultReturnToken = (azureType !== null) ?
          result.accessToken : result.idToken.rawIdToken;
        this.CallUserAPI(resultReturnToken, this.azureInfoService.tenantInfo).subscribe(response => {
          if (response) {
            this.adCallBack(response);
          }
        });
      }
    }, (error: any) => {
      console.log('Get token failed', JSON.stringify(error, null, 2));
      this.azureInfoService.azureOAuthSettings.claims = azureData.idToken.claims
      this.userAgentApp.acquireTokenRedirect(this.azureInfoService.azureOAuthSettings).then((result: any) => {
        if (result && result !== undefined && typeof result === 'object' &&
          (result.hasOwnProperty('accessToken') || result.hasOwnProperty('idToken'))) {
          const resultReturnToken = (azureType !== null && azureType === 'AzureAD') ?
            result.accessToken : result.idToken.rawIdToken;
          this.CallUserAPI(resultReturnToken, this.azureInfoService.tenantInfo).subscribe(response => {
            if (response) {
              this.adCallBack(response);
            }         
          });
        }
      }, (error: any) => {
        console.log('Retry attempt to get token failed', JSON.stringify(error, null, 2));
      })
    })

  }


  async adGetAccessToken(azureType: string = null, azureData: any) {
    this.userAgentApp.acquireTokenSilent(this.azureInfoService.azureOAuthSettings).then(function (accessTokenResponse: any) {
      if (accessTokenResponse && accessTokenResponse !== undefined && typeof accessTokenResponse === 'object' &&
        (accessTokenResponse.hasOwnProperty('accessToken') || accessTokenResponse.hasOwnProperty('idToken'))) {
        const resultReturnToken = (azureType !== null ) ?
          accessTokenResponse.accessToken : accessTokenResponse.idToken.rawIdToken;
        this.CallUserAPI(resultReturnToken, this.azureInfoService.tenantInfo).subscribe(response => {
          if (response) {
            this.adCallBack(response);
          }
        });
      }
    })
      .catch(async (error: any) => {
        console.log(error);
        this.azureInfoService.azureOAuthSettings.claims = azureData.idToken.claims;
        const tokenPopupResult = await this.userAgentApp.acquireTokenRedirect(this.azureInfoService.azureOAuthSettings)
        if (tokenPopupResult && tokenPopupResult !== undefined && typeof tokenPopupResult === 'object' &&
          (tokenPopupResult.hasOwnProperty('accessToken') || tokenPopupResult.hasOwnProperty('idToken'))) {
          const resultReturnToken = (azureType !== null) ?
            tokenPopupResult.accessToken : tokenPopupResult.idToken.rawIdToken;
          this.CallUserAPI(resultReturnToken, this.azureInfoService.tenantInfo).subscribe(response => {
            if (response) {
              this.adCallBack(response);
            }
          });
        }
      });
  }

  adCallBack(adResponse: any): void {
    try {
      if (adResponse) {
        this.LoginInstances = {} as LoginUserInstances;
        this.Roles = adResponse.Roles;
        this.Sites = adResponse.Sites;
        this.ClinetId = adResponse.clientId;
        this.LoginInstances.Locations = adResponse.Locations;
        this.LoginInstances.UserId = adResponse.UserId;
        this.loggedInUserId = adResponse.UserId;
        sessionStorage.setItem('IsAdUser', "true");
        if (adResponse.SessionId) {
          localStorage.setItem(constants.EatecSessionId, adResponse.SessionId);
        }
        if (this.Sites.length > 0) {
          this.locationFrom.controls['site'].setValue(this.Sites[0].Id.toString())
          this.isOneSite = (this.Sites.length === 1) ? true : false;
        }
        if (this.Roles.length > 0) {
          this.locationFrom.controls['instance'].setValue(this.Roles[0].Id.toString());
          this.isOneRole = (this.Roles.length === 1) ? true : false;
        }
        this.loginType = 'Location';
      }
    } catch (error) {
      console.error(error);
    }
  }


  openPopup(headerText, contentText, cancelText, confirmText, navigate) {
    const dialogArray = {
      headerText: headerText,
      contentText: contentText,
      cancelText: cancelText,
      confirmText: confirmText,
      cancelHelpText: 'CANCEL',
      confirmHelpText: 'CONFIRM'
    };
    this.commnService.mobilePopUpProperty.data = dialogArray;
    const dialogRef = this.dialog.open(PopupComponent,
      this.commnService.mobilePopUpProperty
    );

    dialogRef.afterClosed().subscribe((result) => {
      if(navigate === 'Inventory'){
        this.NevigateToInventory();
      }        
      else if(navigate === 'syncfalied'){
        this.router.navigate(['/login']);
      }
    });
  }

 /**
     * @ Params checkAzureType
     * @ param azureType
     * @ returns
     */
 checkAzureType(AzureType: any ): string {
  try {
      let azureAdTypeUserFlow = null;
    if ( AzureType === GlobalConstant.AzureAdType.CUSTOMERB2C ) {
      azureAdTypeUserFlow = GlobalConstant.AzureUserFlow.CUSTOMERUSERFLOW;
    } else if ( AzureType === GlobalConstant.AzureAdType.PRODUCTB2C) {
      azureAdTypeUserFlow = GlobalConstant.AzureUserFlow.AGIYSYSUSERFLOW;
    } else if ( AzureType === GlobalConstant.AzureAdType.LDAP ) {
      azureAdTypeUserFlow = GlobalConstant.AzureUserFlow.LDAPUSERFLOW;
    } else if ( AzureType === GlobalConstant.AzureAdType.AZUREOPENID ) {
      azureAdTypeUserFlow = GlobalConstant.AzureUserFlow.AZUREOPENID;
    } else if ( AzureType === GlobalConstant.AzureAdType.AZUREADSAML ) {
      azureAdTypeUserFlow = GlobalConstant.AzureUserFlow.AZUREADSAML;
    } else if ( AzureType === GlobalConstant.AzureAdType.WORKOSSSO ) {
      azureAdTypeUserFlow = GlobalConstant.AzureUserFlow.WORKOSSSO;
    } else {
      azureAdTypeUserFlow = GlobalConstant.AzureUserFlow.NONEUSERFLOW;
    }
    return azureAdTypeUserFlow;
  } catch ( error ) {
      console.error(error);
  }
}
 /**
   * @method azureAdVerifyEmail
   * @input type result?.account
   * @output None
   * @description Verify the email property from Array type or string
   */
 azureAdVerifyEmail(result: any ): any {
  try{
    let userMail = null;
    if( result?.account?.idTokenClaims?.emails?.length > 0 ){
      userMail = result.account.idTokenClaims.emails[0]
    } else if( result?.account?.idTokenClaims?.email){
      userMail = result.account.idTokenClaims.email
    } else if( result?.account?.username) {
      userMail = result.account.username;
    }else {
      userMail = null;
    }
    return userMail;
  } catch(error){
    console.error(error)
  }
}
 /**
   * @method validateTenantActive
   * @input res
   * @output None
   * @description if tenant is inactive show error popup
   */
 validateTenantActive(): boolean {
  try {
    if (this?.commnService?.tenatconfig?.hasOwnProperty("isActive") && !this?.commnService?.tenatconfig?.isActive) {
      this.showPopUp(this._ts.instant('login.ErrorOccurred'), this._ts.instant('login.InActiveTenant'), '', this._ts.instant('common.ok'));
      return false;
    }
    return true;
  } catch (error) {
    console.error(error);
  }
}
 /**
   * @method azureAdVerifyEmail
   * @input azureType
   * @output None
   * @description set azure type in localStorage
   */
setAzureLoginTypeLocal(AzureType) : void{
  try {

  if ( AzureType === GlobalConstant.AzureAdType.CUSTOMERB2C ) {
    window.localStorage.setItem('LoginAzureType', GlobalConstant.AzureAdType.CUSTOMERB2C);
  } else if ( AzureType === GlobalConstant.AzureAdType.PRODUCTB2C) {
    window.localStorage.setItem('LoginAzureType', GlobalConstant.AzureAdType.PRODUCTB2C);
  } else if ( AzureType === GlobalConstant.AzureAdType.LDAP ) {
    window.localStorage.setItem('LoginAzureType', GlobalConstant.AzureAdType.LDAP);
  } else if ( AzureType === GlobalConstant.AzureAdType.AZUREOPENID ) {
    window.localStorage.setItem('LoginAzureType', GlobalConstant.AzureAdType.AZUREOPENID);
  } else if ( AzureType === GlobalConstant.AzureAdType.AZUREADSAML ) {
    window.localStorage.setItem('LoginAzureType', GlobalConstant.AzureAdType.AZUREADSAML);
  } else if ( AzureType === GlobalConstant.AzureAdType.WORKOSSSO ) {
    window.localStorage.setItem('LoginAzureType', GlobalConstant.AzureAdType.WORKOSSSO);
  }  else {
    window.localStorage.setItem('LoginAzureType', GlobalConstant.AzureAdType.NONE);
  }
} catch ( error ) {
    console.error(error);
}}
}

